(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.initFaicaptcha = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(2));

var _env = __webpack_require__(81);

var _sdk = __webpack_require__(82);

var _version = __webpack_require__(256);

var _util = __webpack_require__(166);

// 缓存 publicPath
// 动态注入 publichPath
__webpack_require__.p = _env.webpackPublichPath; // 编译后会变成
// __webpack_require__.p = webpackPublichPath
// let init = function() {
//   if (console && console.error) {
//     console.error('sdk did not download finished');
//   }
// };
// import(/* webpackChunkName: "sdk" */ '@/src/sdk').then(({ _init }) => {
//   init = _init;
// });

/**
 * 获取 ak 的函数函数
 *
 * @callback GenAccessKey
 * @param {(cb: (ak: string) => void) => void} callback 回调函数，传入 ak
 */

/**
 * @name initFaicaptcha
 * @description 初始化验证码
 * @param {object} userConfig 用户配置
 * @param {number} userConfig.bss *（v1必填）业务团队，参考fai.app.CaptchaDef.Bss
 * @param {string} userConfig.bssKey *（v1必填）业务场景的唯一标识，由架构绪强颁发
 * @param {GenAccessKey} userConfig.genAccessKey *（v2必填）获取 ak 的函数
 * @param {string} userConfig.captchaServer （v1必填，v2不需要填）验证码服务端地址，默认取全局配置的 window.__CAPTCHA_SERVER__
 * @param {string} userConfig.lang 多语言设置，默认是中文，支持中文（zh-CN）、繁体中文（zh-CW）、英文（en）、日文（ja）、老挝（lo）、法文（fr）、泰文（th）、韩文（ko）、意大利文（it）、德文（de）、俄文（ru）、西班牙（es）
 * @param {Function} userConfig.errorHandler 错误处理函数。类型 Function(xhr: XMLHttpRequest, type: TextStatus, error: Error)
 * XMLHttpRequest：原生 xhr 对象
 * TextStatus：表示返回的状态，根据服务器不同的错误可能返回下面这些信息："timeout"（超时）, "error"（错误）, "abort"(中止), "parsererror"（解析错误）
 * Error：解析错误时的错误信息
 * @param {Function|null} userConfig.getPopupContainer 弹出框渲染父节点，默认渲染到 body 上。类型 Function(triggerNode)，默认值 () => document.body
 * @param {boolean} userConfig.maskClosable 点击蒙层是否允许关闭
 * @param {number|null} userConfig.zIndex 设置弹层的 z-index
 * @param {(checkSign: string) => void} onSuccess 成功回调，checkSign - 返回验证签名
 * @param {() => void} onClose 关闭回调，顺序在成功回调之后
 * @param {string} userConfig.force_fallback 直接使用回退模式，使用图形验证码，默认false
 */
var initFaicaptcha = function initFaicaptcha(userConfig, onSuccess, onClose) {
  if (userConfig === void 0) {
    userConfig = {};
  }

  // 参数处理
  var DEFAULT_USER_CONFIG = {
    captchaServer: _env.captchaServer,
    errorHandler: _util.noop
  };
  userConfig = (0, _extends2.default)({}, DEFAULT_USER_CONFIG, userConfig); // 参数校验

  if (!userConfig.genAccessKey && !userConfig.captchaServer) {
    (0, _util.warn)("\n\uFF08\u4EE5\u4E0B\u4E8C\u9009\u4E00\u4E2A\u65B9\u5F0F\u4F20\u5165\uFF09\nv2 \u7F3A\u5931\u83B7\u53D6 ak \u7684\u51FD\u6570\uFF0C\u8BF7\u4F20\u5165 [userConfig.genAccessKey]\nv1 \u7F3A\u5931\u9A8C\u8BC1\u7801\u670D\u52A1\u7AEF\u5730\u5740\uFF0C\u8BF7\u4F20\u5165 [userConfig.captchaServer] \u6216\u8005\u58F0\u660E\u5168\u5C40\u914D\u7F6E [window.__CAPTCHA_SERVER__]\n      ");
  }

  if (userConfig.force_fallback && userConfig.genAccessKey) {
    (0, _util.warn)('请通过后端配置方式指定验证码类型，属性 [userConfig.force_fallback] 在新版API下无法使用');
    userConfig.force_fallback = false;
  } // 初始化


  (0, _sdk._init)(userConfig, onSuccess, onClose);
}; // 注入版本号


exports.initFaicaptcha = initFaicaptcha;
initFaicaptcha.version = _version.version;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$assign = __webpack_require__(3);

var _bindInstanceProperty = __webpack_require__(70);

function _extends() {
  var _context;

  module.exports = _extends = _Object$assign ? _bindInstanceProperty(_context = _Object$assign).call(_context) : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(6);

module.exports = parent;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(7);

module.exports = parent;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(8);

module.exports = parent;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(9);
var path = __webpack_require__(32);

module.exports = path.Object.assign;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(10);
var assign = __webpack_require__(58);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var apply = __webpack_require__(13);
var uncurryThis = __webpack_require__(16);
var isCallable = __webpack_require__(17);
var getOwnPropertyDescriptor = __webpack_require__(18).f;
var isForced = __webpack_require__(52);
var path = __webpack_require__(32);
var bind = __webpack_require__(53);
var createNonEnumerableProperty = __webpack_require__(54);
var hasOwn = __webpack_require__(47);

var wrapConstructor = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof Wrapper) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return apply(NativeConstructor, this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global : STATIC ? global[TARGET] : (global[TARGET] || {}).prototype;

  var target = GLOBAL ? path : path[TARGET] || createNonEnumerableProperty(path, TARGET, {})[TARGET];
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && hasOwn(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (USE_NATIVE && typeof targetProperty == typeof sourceProperty) continue;

    // bind timers to global for call from export context
    if (options.bind && USE_NATIVE) resultProperty = bind(sourceProperty, global);
    // wrap global constructors for prevent changs in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && isCallable(sourceProperty)) resultProperty = uncurryThis(sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(resultProperty, 'sham', true);
    }

    createNonEnumerableProperty(target, key, resultProperty);

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!hasOwn(path, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      createNonEnumerableProperty(path[VIRTUAL_PROTOTYPE], key, sourceProperty);
      // export real prototype methods
      if (options.real && targetPrototype && !targetPrototype[key]) {
        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
      }
    }
  }
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(12)))

/***/ }),
/* 12 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(14);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es-x/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(15);

module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(14);

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var uncurryThis = NATIVE_BIND && bind.bind(call, call);

module.exports = NATIVE_BIND ? function (fn) {
  return fn && uncurryThis(fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var call = __webpack_require__(20);
var propertyIsEnumerableModule = __webpack_require__(21);
var createPropertyDescriptor = __webpack_require__(22);
var toIndexedObject = __webpack_require__(23);
var toPropertyKey = __webpack_require__(27);
var hasOwn = __webpack_require__(47);
var IE8_DOM_DEFINE = __webpack_require__(50);

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(15);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(14);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(24);
var requireObjectCoercible = __webpack_require__(26);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(16);
var fails = __webpack_require__(15);
var classof = __webpack_require__(25);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(16);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__(28);
var isSymbol = __webpack_require__(30);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__(20);
var isObject = __webpack_require__(29);
var isSymbol = __webpack_require__(30);
var getMethod = __webpack_require__(38);
var ordinaryToPrimitive = __webpack_require__(41);
var wellKnownSymbol = __webpack_require__(42);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__(17);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(31);
var isCallable = __webpack_require__(17);
var isPrototypeOf = __webpack_require__(33);
var USE_SYMBOL_AS_UID = __webpack_require__(34);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(32);
var global = __webpack_require__(11);
var isCallable = __webpack_require__(17);

var aFunction = function (variable) {
  return isCallable(variable) ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(16);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es-x/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(35);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es-x/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(36);
var fails = __webpack_require__(15);

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var userAgent = __webpack_require__(37);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(31);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__(39);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__(17);
var tryToString = __webpack_require__(40);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__(20);
var isCallable = __webpack_require__(17);
var isObject = __webpack_require__(29);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var shared = __webpack_require__(43);
var hasOwn = __webpack_require__(47);
var uid = __webpack_require__(49);
var NATIVE_SYMBOL = __webpack_require__(35);
var USE_SYMBOL_AS_UID = __webpack_require__(34);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(44);
var store = __webpack_require__(45);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.23.3',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var defineGlobalProperty = __webpack_require__(46);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(16);
var toObject = __webpack_require__(48);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(26);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(16);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var fails = __webpack_require__(15);
var createElement = __webpack_require__(51);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var isObject = __webpack_require__(29);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(15);
var isCallable = __webpack_require__(17);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(16);
var aCallable = __webpack_require__(39);
var NATIVE_BIND = __webpack_require__(14);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var definePropertyModule = __webpack_require__(55);
var createPropertyDescriptor = __webpack_require__(22);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var IE8_DOM_DEFINE = __webpack_require__(50);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(56);
var anObject = __webpack_require__(57);
var toPropertyKey = __webpack_require__(27);

var $TypeError = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var fails = __webpack_require__(15);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(19);
var uncurryThis = __webpack_require__(16);
var call = __webpack_require__(20);
var fails = __webpack_require__(15);
var objectKeys = __webpack_require__(59);
var getOwnPropertySymbolsModule = __webpack_require__(69);
var propertyIsEnumerableModule = __webpack_require__(21);
var toObject = __webpack_require__(48);
var IndexedObject = __webpack_require__(24);

// eslint-disable-next-line es-x/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es-x/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(60);
var enumBugKeys = __webpack_require__(68);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(16);
var hasOwn = __webpack_require__(47);
var toIndexedObject = __webpack_require__(23);
var indexOf = __webpack_require__(61).indexOf;
var hiddenKeys = __webpack_require__(67);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(23);
var toAbsoluteIndex = __webpack_require__(62);
var lengthOfArrayLike = __webpack_require__(65);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(63);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var trunc = __webpack_require__(64);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__(66);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(63);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(71);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(72);


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(73);

module.exports = parent;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(74);

module.exports = parent;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(75);

module.exports = parent;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(33);
var method = __webpack_require__(76);

var FunctionPrototype = Function.prototype;

module.exports = function (it) {
  var own = it.bind;
  return it === FunctionPrototype || (isPrototypeOf(FunctionPrototype, it) && own === FunctionPrototype.bind) ? method : own;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(77);
var entryVirtual = __webpack_require__(80);

module.exports = entryVirtual('Function').bind;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
var $ = __webpack_require__(10);
var bind = __webpack_require__(78);

// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
$({ target: 'Function', proto: true, forced: Function.bind !== bind }, {
  bind: bind
});


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(16);
var aCallable = __webpack_require__(39);
var isObject = __webpack_require__(29);
var hasOwn = __webpack_require__(47);
var arraySlice = __webpack_require__(79);
var NATIVE_BIND = __webpack_require__(14);

var $Function = Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(16);

module.exports = uncurryThis([].slice);


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(32);

module.exports = function (CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.webpackPublichPath = exports.captchaServer = void 0;
var webpackPublichPath = window.__webpack_public_path__;
exports.webpackPublichPath = webpackPublichPath;
var captchaServer = window.__CAPTCHA_SERVER__;
exports.captchaServer = captchaServer;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports._init = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(2));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(83));

var _core = __webpack_require__(100);

var _api = __webpack_require__(250);

var _util = __webpack_require__(166);

var _i18n = _interopRequireDefault(__webpack_require__(257));

var _fns = __webpack_require__(258);

var _excluded = ["lang", "bss", "bssKey", "captchaServer"];
var existing = false;

var _init = function _init(userConfig, onSuccess, onClose) {
  if (onSuccess === void 0) {
    onSuccess = _util.noop;
  }

  if (onClose === void 0) {
    onClose = _util.noop;
  }

  if (existing) {
    return;
  }

  existing = true;
  var lang = userConfig.lang,
      bss = userConfig.bss,
      bssKey = userConfig.bssKey,
      captchaServer = userConfig.captchaServer,
      options = (0, _objectWithoutPropertiesLoose2.default)(userConfig, _excluded); // 初始化多语言

  var _i18n$init = _i18n.default.init({
    lang: lang
  }),
      t = _i18n$init.t; // 初始化api


  (0, _api.setup)({
    captcha_server: captchaServer,
    bss: bss,
    bssKey: bssKey
  });
  var validateSignRef = {
    value: ''
  };
  var eoRef = {
    value: {}
  };
  var accessKeyRef = {
    value: ''
  };
  var faicaptcha = new _core.Faicaptcha((0, _extends2.default)({}, options, {
    title: t('please'),
    t: t,
    version: userConfig.genAccessKey ? 2 : 1,
    fallback: function fallback(cb) {
      var confirmText = t('confirm');
      var correct = t('correct');
      var placeholder = t('placeholder');
      (0, _api.init)({
        success: function success(data) {
          if (data && data.success) {
            cb({
              imgUrl: "data:image/png;base64," + data.msg.imgId,
              confirmText: confirmText,
              correct: correct,
              placeholder: placeholder
            });
            validateSignRef.value = data.msg.validateSign;
          } else {
            cb({
              imgUrl: '',
              confirmText: confirmText,
              correct: correct,
              placeholder: placeholder
            });
          }
        },
        error: function error(xhr, type, _error) {
          cb({
            imgUrl: '',
            confirmText: confirmText,
            correct: correct,
            placeholder: placeholder
          });
          userConfig.errorHandler(xhr, type, _error);
        }
      });
    }
  }));
  faicaptcha.on('beforeDestroy', function () {
    onClose();
    existing = false;
  }); // 生成版本方法

  var start = (0, _fns.createStartFn)(userConfig, faicaptcha, t, validateSignRef, eoRef, accessKeyRef);
  var validate = (0, _fns.createValidateFn)(userConfig, faicaptcha, t, validateSignRef, eoRef, accessKeyRef, onSuccess); // 旋转发起验证

  faicaptcha.on('validate2', function (args) {
    validate(args, 2);
  }); // 滑块发起验证

  faicaptcha.on('validate', function (args) {
    validate(args, 1);
  }); // 图片发起验证

  faicaptcha.on('validate0', function (args) {
    validate(args, 0);
  }); // 重刷新

  faicaptcha.on('restart', function () {
    start();
  });
  faicaptcha.on('fallbackEnd', function (data) {
    onSuccess(data, true);
  }); // 图形tips

  faicaptcha.on('updateTipsForGraphic', function (text) {
    faicaptcha.emit('updateTipsGraphic', text || t('correct'));
  });
  faicaptcha.on('initForGraphic', function () {
    faicaptcha.emit('initGraphic', t('placeholder'), t('confirm'));
  }); // start

  if (userConfig.genAccessKey) {
    start();
    faicaptcha.emit('updateTips', t('slideRight'));
  } else {
    if (!userConfig.force_fallback && !(_util.Env.isIE9 || _util.Env.isIE8 || _util.Env.isIE7)) {
      start();
      faicaptcha.emit('updateTips', t('slideRight'));
    } else {
      // text
      faicaptcha.emit('updateTips', '');
      faicaptcha.emit('fallback');
    }
  }
};

exports._init = _init;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$keys = __webpack_require__(84);

var _indexOfInstanceProperty = __webpack_require__(91);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = _Object$keys(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (_indexOfInstanceProperty(excluded).call(excluded, key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(85);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(86);


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(87);

module.exports = parent;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(88);

module.exports = parent;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(89);

module.exports = parent;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90);
var path = __webpack_require__(32);

module.exports = path.Object.keys;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(10);
var toObject = __webpack_require__(48);
var nativeKeys = __webpack_require__(59);
var fails = __webpack_require__(15);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(92);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(93);


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(94);

module.exports = parent;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(95);

module.exports = parent;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(96);

module.exports = parent;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(33);
var method = __webpack_require__(97);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.indexOf;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.indexOf) ? method : own;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(98);
var entryVirtual = __webpack_require__(80);

module.exports = entryVirtual('Array').indexOf;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es-x/no-array-prototype-indexof -- required for testing */
var $ = __webpack_require__(10);
var uncurryThis = __webpack_require__(16);
var $IndexOf = __webpack_require__(61).indexOf;
var arrayMethodIsStrict = __webpack_require__(99);

var un$IndexOf = uncurryThis([].indexOf);

var NEGATIVE_ZERO = !!un$IndexOf && 1 / un$IndexOf([1], 1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? un$IndexOf(this, searchElement, fromIndex) || 0
      : $IndexOf(this, searchElement, fromIndex);
  }
});


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(15);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.Faicaptcha = void 0;

var _parseInt2 = _interopRequireDefault(__webpack_require__(101));

var _concat = _interopRequireDefault(__webpack_require__(111));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(124));

var _splice = _interopRequireDefault(__webpack_require__(131));

var _parseFloat2 = _interopRequireDefault(__webpack_require__(137));

var _extends2 = _interopRequireDefault(__webpack_require__(2));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(142));

__webpack_require__(164);

__webpack_require__(165);

var _util = __webpack_require__(166);

var _modal = __webpack_require__(244);

var _status = __webpack_require__(247);

var _lock = __webpack_require__(248);

var _indexTpl = _interopRequireDefault(__webpack_require__(249));

var Faicaptcha = /*#__PURE__*/function (_EventEmitter) {
  (0, _inheritsLoose2.default)(Faicaptcha, _EventEmitter);

  function Faicaptcha(options) {
    var _this;

    _this = _EventEmitter.call(this) || this;

    _this._init(options);

    return _this;
  }

  var _proto = Faicaptcha.prototype;

  _proto._init = function _init(options) {
    this._render(options);

    if (options.version === 2) {
      this._bindEvent(options);
    } else {
      if (!(_util.Env.isIE9 || _util.Env.isIE8 || _util.Env.isIE7)) {
        this._bindEvent(options);
      }

      this._bindFallbackEvent(options);
    }
  };

  _proto._render = function _render(options) {
    var _this2 = this;

    this.modal = (0, _modal.initModal)((0, _extends2.default)({}, options, {
      body: _indexTpl.default,
      beforeClose: function beforeClose() {
        if (_lock.LOCKED) return false;
      },
      beforeDestroy: function beforeDestroy() {
        _this2.emit('beforeDestroy');

        _this2.removeAllListeners();

        _this2.modal = null;
        (0, _lock.unlock)();
      },
      getPopupContainer: options.getPopupContainer
    }));
    this.modal.mount();
  };

  _proto._getDOM = function _getDOM(className) {
    return (0, _util.query)('.' + className, this.modal.ref)[0];
  };

  _proto._useSlider = function _useSlider(_ref) {
    var _this3 = this;

    var maxWidth = _ref.maxWidth,
        originalClientX = _ref.originalClientX;
    var originalWidth = (0, _util.getStyleFloatValue)(this._getDOM('faicaptcha_slide--track'), 'width');

    var updateWidth = function updateWidth(currentClientX) {
      var _nextWidth = originalWidth + (currentClientX - originalClientX);

      var nextWidth = _nextWidth > maxWidth ? maxWidth : _nextWidth < originalWidth ? originalWidth : _nextWidth;
      _this3._getDOM('faicaptcha_slide--track').style.width = nextWidth + 'px';
    };

    var updateSlider = function updateSlider(_ref2) {
      var currentClientX = _ref2.currentClientX;
      updateWidth(currentClientX);
    };

    return [originalWidth, updateSlider];
  };

  _proto._usePiece = function _usePiece(_ref3) {
    var _this4 = this;

    var maxLeft = _ref3.maxLeft,
        originalClientX = _ref3.originalClientX;
    var originPieceLeft = (0, _util.getStyleFloatValue)(this._getDOM('faicaptcha_slide--piece'), 'left');
    var originalLeft = this.captchaType === 2 ? 0 : originPieceLeft;
    var pieceLeft = originalLeft;

    var toRotate = function toRotate(left) {
      return left / maxLeft * 360;
    };

    var updateLeft = function updateLeft(currentClientX) {
      var _nextLeft = originalLeft + (currentClientX - originalClientX) / (_this4._slideRadio || 1);

      var nextLeft = _nextLeft > maxLeft ? maxLeft : _nextLeft < originalLeft ? originalLeft : _nextLeft;

      if (_this4.captchaType === 2) {
        _this4._getDOM('faicaptcha_slide--piece').style.transform = "rotate(" + toRotate(nextLeft) + "deg)";
      } else {
        _this4._getDOM('faicaptcha_slide--piece').style.left = nextLeft + 'px';
      }

      pieceLeft = nextLeft;
    };

    var getPieceLeft = function getPieceLeft() {
      if (_this4.captchaType === 2) {
        return toRotate(pieceLeft);
      } else {
        return (0, _parseInt2.default)(pieceLeft * (_this4._sizeRadio || 1));
      }
    };

    var updatePiece = function updatePiece(_ref4) {
      var currentClientX = _ref4.currentClientX;
      updateLeft(currentClientX);
    };

    return [getPieceLeft, updatePiece];
  };

  _proto._bindEvent = function _bindEvent(options) {
    var _this5 = this;

    var VC_INIT_POINT_NUM = 20;
    var VC_MOVE_POINT_NUM = 20;
    var globalTrack = [];
    var globalTrackRunner = (0, _util.throttle)(function (e) {
      e = e.targetTouches ? e.targetTouches[0] : e || window.event; // console.log(globalTrack);

      if (globalTrack.length < VC_INIT_POINT_NUM) {
        globalTrack.push([e.clientX, e.clientY, new Date().getTime(), 0, 0]);
      } else {
        _util.EventHandler.off(document, 'mousemove', globalTrackRunner);

        _util.EventHandler.off(document, 'touchmove', globalTrackRunner);
      }
    }, 500);

    _util.EventHandler.on(document, 'mousemove', globalTrackRunner);

    _util.EventHandler.on(document, 'touchmove', globalTrackRunner);

    this.on('beforeDestroy', function () {
      _util.EventHandler.off(document, 'mousemove', globalTrackRunner);

      _util.EventHandler.off(document, 'touchmove', globalTrackRunner);
    });

    var moveRunner = function moveRunner(e) {
      var _context;

      e.preventDefault && e.preventDefault();
      if (_lock.LOCKED) return;
      (0, _lock.lock)();

      _util.EventHandler.off(document, 'mousemove', globalTrackRunner);

      _util.EventHandler.off(document, 'touchmove', globalTrackRunner);

      var track = (0, _concat.default)(_context = []).call(_context, globalTrack);
      var originalClientX = e.clientX;
      var downY = e.clientY;

      var _this5$_useSlider = _this5._useSlider({
        maxWidth: (0, _util.getStyleFloatValue)(_this5._getDOM('faicaptcha_slide--track_wrap'), 'width'),
        originalClientX: originalClientX
      }),
          trackWidth = _this5$_useSlider[0],
          updateSlider = _this5$_useSlider[1];

      var puzzleWidth = (0, _util.getStyleFloatValue)(_this5._getDOM('faicaptcha_slide--puzzle'), 'width');
      var pieceWidth = (0, _util.getStyleFloatValue)(_this5._getDOM('faicaptcha_slide--piece'), 'width');
      var maxLeft = _this5.captchaType === 2 ? puzzleWidth : puzzleWidth - pieceWidth;

      var _this5$_usePiece = _this5._usePiece({
        maxLeft: maxLeft,
        originalClientX: originalClientX
      }),
          getPieceLeft = _this5$_usePiece[0],
          updatePiece = _this5$_usePiece[1];

      var updatePieceStatus = (0, _status.useStatus)(_this5._getDOM('faicaptcha_slide--piece'), (0, _status.getStatusList)('faicaptcha_slide--piece'));
      var updateSliderStatus = (0, _status.useStatus)(_this5._getDOM('faicaptcha_slide--slider'), (0, _status.getStatusList)('faicaptcha_slide--slider'));
      var updateTrackStatus = (0, _status.useStatus)(_this5._getDOM('faicaptcha_slide--track'), (0, _status.getStatusList)('faicaptcha_slide--track'));
      var updateAnchorStatus = (0, _status.useStatus)(_this5._getDOM('faicaptcha_slide--anchor'), (0, _status.getStatusList)('faicaptcha_slide--anchor'));

      var handleStart = function handleStart(e) {
        if (track.length < VC_INIT_POINT_NUM + VC_MOVE_POINT_NUM) {
          track.push([e.clientX, e.clientY, new Date().getTime(), 1, 1]);
        }

        updateSlider({
          currentClientX: e.clientX
        });
        updatePiece({
          currentClientX: e.clientX
        });
        updatePieceStatus('active');
        updateSliderStatus('active');
        updateTrackStatus('active');
        updateAnchorStatus('active');
      };

      var handleMove = function handleMove(e) {
        if (track.length < VC_INIT_POINT_NUM + VC_MOVE_POINT_NUM) {
          track.push([e.clientX, e.clientY, new Date().getTime(), 2, 1]);
        }

        updateSlider({
          currentClientX: e.clientX
        });
        updatePiece({
          currentClientX: e.clientX
        });
      };

      var handleEnd = function handleEnd(e) {
        if (track.length < VC_INIT_POINT_NUM + VC_MOVE_POINT_NUM) {
          track.push([e.clientX, e.clientY, new Date().getTime(), 3, 1]);
        }

        var upY = e.clientY;
        var validateEventName = _this5.captchaType === 2 ? 'validate2' : 'validate';

        _this5.emit(validateEventName, {
          left: getPieceLeft(),
          downY: downY,
          upY: upY,
          track: track
        });

        var validatedEventName = _this5.captchaType === 2 ? 'validated2' : 'validated';

        _this5.once(validatedEventName, function (_ref5) {
          var success = _ref5.success;

          if (success) {
            updateSliderStatus('success');
            updateTrackStatus('success');
            updateAnchorStatus('success');
            updateSlider({
              currentClientX: originalClientX
            });
            (0, _setTimeout2.default)(function () {
              (0, _lock.unlock)();

              _this5.emit('finished');

              _this5.modal.close();
            }, 500);
          } else {
            updatePieceStatus('normal');
            updateTrackStatus('dangerous');
            updateSliderStatus('dangerous');
            updateAnchorStatus('dangerous', _lock.unlock);
            updateSlider({
              currentClientX: originalClientX
            });
            updatePiece({
              currentClientX: originalClientX
            });
            (0, _splice.default)(globalTrack).call(globalTrack, 0, globalTrack.length);

            _util.EventHandler.on(document, 'mousemove', globalTrackRunner);

            _util.EventHandler.on(document, 'touchmove', globalTrackRunner);
          }
        });
      };

      handleStart(e);
      return [handleMove, handleEnd];
    };

    (0, _util.moveRecognizer)(this._getDOM('faicaptcha_slide--anchor'), moveRunner);

    var restart = function restart() {
      if (_lock.LOCKED) return;
      (0, _lock.lock)();

      _this5.emit('restart');
    };

    _util.EventHandler.on(this._getDOM('faicaptcha_slide--img'), 'click', restart);

    _util.EventHandler.on(this._getDOM('faicaptcha_slide--piece'), 'click', restart);

    this.on('setup', function (_ref6) {
      var imgUrl = _ref6.imgUrl,
          pieceTop = _ref6.pieceTop,
          _ref6$pieceLeft = _ref6.pieceLeft,
          pieceLeft = _ref6$pieceLeft === void 0 ? 0 : _ref6$pieceLeft,
          sliderUrl = _ref6.sliderUrl,
          sliderWidth = _ref6.sliderWidth,
          sliderHeight = _ref6.sliderHeight,
          imgWidth = _ref6.imgWidth,
          imgHeight = _ref6.imgHeight,
          captchaType = _ref6.captchaType,
          placeholder = _ref6.placeholder,
          confirmText = _ref6.confirmText;
      // 保存验证码类型
      _this5.captchaType = captchaType; // APIv2 使用图片验证码直接在 setup 事件里初始化

      if (_this5.captchaType === 0) {
        _this5._getDOM('faicaptcha_slide').style.display = 'none';
        _this5._getDOM('faicaptcha_graphic').style.display = 'block';
        _this5._getDOM('faicaptcha_graphic--img').src = imgUrl;
        (0, _lock.unlock)();
        return;
      } // 使用滑块验证码
      // 底图


      (0, _util.loadImg)(imgUrl, function () {
        _this5._getDOM('faicaptcha_slide--img').src = imgUrl;
        _this5._getDOM('faicaptcha_slide--img').style.display = 'block'; // this._getDOM('faicaptcha_slide--img').style.width = imgWidth + 'px';
        // this._getDOM('faicaptcha_slide--img').style.height = imgHeight + 'px';

        _this5._getDOM('faicaptcha_slide--placeholder').style.display = 'none'; // 加载拼图图片

        (0, _util.loadImg)(sliderUrl, function () {
          var puzzleWidth = (0, _util.getStyleFloatValue)(_this5._getDOM('faicaptcha_slide--puzzle'), 'width'); // 尺寸缩放比例

          _this5._sizeRadio = (0, _parseFloat2.default)(imgWidth) / puzzleWidth; // 初始化拼图样式

          var pieceWidth = (0, _parseFloat2.default)(sliderWidth) / _this5._sizeRadio;

          var pieceHeight = (0, _parseFloat2.default)(sliderHeight) / _this5._sizeRadio;

          var _pieceTop = pieceTop / _this5._sizeRadio;

          var _pieceLeft = pieceLeft / _this5._sizeRadio;

          _this5._getDOM('faicaptcha_slide--piece').src = sliderUrl;
          _this5._getDOM('faicaptcha_slide--piece').style.top = _pieceTop + 'px';
          _this5._getDOM('faicaptcha_slide--piece').style.left = _pieceLeft + 'px';
          _this5._getDOM('faicaptcha_slide--piece').style.width = pieceWidth + 'px';
          _this5._getDOM('faicaptcha_slide--piece').style.height = pieceHeight + 'px';
          _this5._getDOM('faicaptcha_slide--piece').style.display = 'block'; // 滑动缩放比例

          var trackWrapWidth = (0, _util.getStyleFloatValue)(_this5._getDOM('faicaptcha_slide--track_wrap'), 'width');
          (0, _util.whenTransitionend)(_this5._getDOM('faicaptcha_slide--track'), function () {
            var trackWidth = (0, _util.getStyleFloatValue)(_this5._getDOM('faicaptcha_slide--track'), 'width');

            if (_this5.captchaType === 2) {
              _this5._slideRadio = (trackWrapWidth - trackWidth) / puzzleWidth;
            } else {
              _this5._slideRadio = (trackWrapWidth - trackWidth) / (puzzleWidth - pieceWidth);
            }

            (0, _lock.unlock)();
          });
        });
      });
    });
    this.on('updateTips', function (label) {
      _this5._getDOM('faicaptcha_slide--label').innerHTML = label;
      _this5._getDOM('faicaptcha_slide--label').title = label;
    });

    if (options.version === 2) {
      this.on('updateTipsGraphic', function (label) {
        _this5._getDOM('faicaptcha_graphic--tips').innerHTML = label;
      });
      this.on('initGraphic', function (placeholder, confirmText) {
        _this5._getDOM('faicaptcha_graphic--input').placeholder = placeholder;
        _this5._getDOM('faicaptcha_graphic--confirm').innerHTML = confirmText;
      }); // 图形验证码 - 刷新

      _util.EventHandler.on(this._getDOM('faicaptcha_graphic--img'), 'click', restart);

      _util.EventHandler.on(this._getDOM('faicaptcha_graphic--refresh'), 'click', restart); // 图形验证码 - 确认


      _util.EventHandler.on(this._getDOM('faicaptcha_graphic--confirm'), 'click', function () {
        var val = _this5._getDOM('faicaptcha_graphic--input').value;

        if (val.length < 4) {
          restart();

          _this5.emit('updateTipsForGraphic');
        } else {
          _this5.emit('validate0', {
            code: val
          });

          _this5.once('validated0', function (_ref7) {
            var success = _ref7.success;

            if (success) {
              (0, _setTimeout2.default)(function () {
                (0, _lock.unlock)();

                _this5.emit('finished');

                _this5.modal.close();
              }, 500);
            } else {
              (0, _lock.unlock)();
            }
          });
        }
      });
    }
  };

  _proto._bindFallbackEvent = function _bindFallbackEvent(options) {
    var _this6 = this;

    // fallback
    this.on('fallback', function () {
      (0, _lock.unlock)();
      _this6._getDOM('faicaptcha_slide').style.display = 'none';
      _this6._getDOM('faicaptcha_graphic').style.display = 'block';

      _this6.on('updateTips', function (label) {
        _this6._getDOM('faicaptcha_graphic--tips').innerHTML = label;
      });

      var onFallback = function onFallback(_ref8) {
        var imgUrl = _ref8.imgUrl,
            placeholder = _ref8.placeholder,
            confirmText = _ref8.confirmText,
            tips = _ref8.tips;
        _this6._getDOM('faicaptcha_graphic--img').src = imgUrl;
        _this6._getDOM('faicaptcha_graphic--input').placeholder = placeholder;
        _this6._getDOM('faicaptcha_graphic--confirm').innerHTML = confirmText;

        if (tips) {
          _this6._getDOM('faicaptcha_graphic--tips').innerHTML = tips;
        }
      };

      options.fallback(onFallback); // 图形验证码 - 刷新

      var refreshImg = function refreshImg() {
        options.fallback(function (_ref9) {
          var imgUrl = _ref9.imgUrl;
          _this6._getDOM('faicaptcha_graphic--img').src = imgUrl;
        });
      };

      _this6.on('refreshImg', refreshImg);

      _util.EventHandler.on(_this6._getDOM('faicaptcha_graphic--img'), 'click', refreshImg);

      _util.EventHandler.on(_this6._getDOM('faicaptcha_graphic--refresh'), 'click', refreshImg); // 图形验证码 - 确认


      _util.EventHandler.on(_this6._getDOM('faicaptcha_graphic--confirm'), 'click', function () {
        var val = _this6._getDOM('faicaptcha_graphic--input').value;

        if (val.length < 4) {
          options.fallback(function (_ref10) {
            var correct = _ref10.correct;
            _this6._getDOM('faicaptcha_graphic--tips').innerHTML = correct;
          });
        } else {
          _this6.emit('validate0', {
            code: val
          });

          _this6.once('validated0', function (_ref11) {
            var success = _ref11.success;

            if (success) {
              (0, _setTimeout2.default)(function () {
                (0, _lock.unlock)();

                _this6.emit('finished');

                _this6.modal.close();
              }, 500);
            } else {
              (0, _lock.unlock)();
            }
          });
        }
      });
    });
  };

  return Faicaptcha;
}(_util.EventEmitter);

exports.Faicaptcha = Faicaptcha;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(102);

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(103);

module.exports = parent;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(104);
var path = __webpack_require__(32);

module.exports = path.parseInt;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(10);
var $parseInt = __webpack_require__(105);

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != $parseInt }, {
  parseInt: $parseInt
});


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var fails = __webpack_require__(15);
var uncurryThis = __webpack_require__(16);
var toString = __webpack_require__(106);
var trim = __webpack_require__(109).trim;
var whitespaces = __webpack_require__(110);

var $parseInt = global.parseInt;
var Symbol = global.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(107);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(108);
var isCallable = __webpack_require__(17);
var classofRaw = __webpack_require__(25);
var wellKnownSymbol = __webpack_require__(42);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(42);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(16);
var requireObjectCoercible = __webpack_require__(26);
var toString = __webpack_require__(106);
var whitespaces = __webpack_require__(110);

var replace = uncurryThis(''.replace);
var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(112);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(113);

module.exports = parent;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(33);
var method = __webpack_require__(114);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.concat;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.concat) ? method : own;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115);
var entryVirtual = __webpack_require__(80);

module.exports = entryVirtual('Array').concat;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(10);
var fails = __webpack_require__(15);
var isArray = __webpack_require__(116);
var isObject = __webpack_require__(29);
var toObject = __webpack_require__(48);
var lengthOfArrayLike = __webpack_require__(65);
var doesNotExceedSafeInteger = __webpack_require__(117);
var createProperty = __webpack_require__(118);
var arraySpeciesCreate = __webpack_require__(119);
var arrayMethodHasSpeciesSupport = __webpack_require__(123);
var wellKnownSymbol = __webpack_require__(42);
var V8_VERSION = __webpack_require__(36);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(25);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es-x/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),
/* 117 */
/***/ (function(module, exports) {

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__(27);
var definePropertyModule = __webpack_require__(55);
var createPropertyDescriptor = __webpack_require__(22);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__(120);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(116);
var isConstructor = __webpack_require__(121);
var isObject = __webpack_require__(29);
var wellKnownSymbol = __webpack_require__(42);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(16);
var fails = __webpack_require__(15);
var isCallable = __webpack_require__(17);
var classof = __webpack_require__(107);
var getBuiltIn = __webpack_require__(31);
var inspectSource = __webpack_require__(122);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(16);
var isCallable = __webpack_require__(17);
var store = __webpack_require__(45);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(15);
var wellKnownSymbol = __webpack_require__(42);
var V8_VERSION = __webpack_require__(36);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(125);

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(126);
var path = __webpack_require__(32);

module.exports = path.setTimeout;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(127);
__webpack_require__(130);


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(10);
var global = __webpack_require__(11);
var setInterval = __webpack_require__(128).setInterval;

// ie9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$({ global: true, bind: true, forced: global.setInterval !== setInterval }, {
  setInterval: setInterval
});


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var apply = __webpack_require__(13);
var isCallable = __webpack_require__(17);
var userAgent = __webpack_require__(37);
var arraySlice = __webpack_require__(79);
var validateArgumentsLength = __webpack_require__(129);

var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var Function = global.Function;

var wrap = function (scheduler) {
  return MSIE ? function (handler, timeout /* , ...arguments */) {
    var boundArgs = validateArgumentsLength(arguments.length, 1) > 2;
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = boundArgs ? arraySlice(arguments, 2) : undefined;
    return scheduler(boundArgs ? function () {
      apply(fn, this, args);
    } : fn, timeout);
  } : scheduler;
};

// ie9- setTimeout & setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
module.exports = {
  // `setTimeout` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
  setTimeout: wrap(global.setTimeout),
  // `setInterval` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
  setInterval: wrap(global.setInterval)
};


/***/ }),
/* 129 */
/***/ (function(module, exports) {

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(10);
var global = __webpack_require__(11);
var setTimeout = __webpack_require__(128).setTimeout;

// ie9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$({ global: true, bind: true, forced: global.setTimeout !== setTimeout }, {
  setTimeout: setTimeout
});


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(132);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(133);

module.exports = parent;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(33);
var method = __webpack_require__(134);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.splice;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.splice) ? method : own;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(135);
var entryVirtual = __webpack_require__(80);

module.exports = entryVirtual('Array').splice;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(10);
var toObject = __webpack_require__(48);
var toAbsoluteIndex = __webpack_require__(62);
var toIntegerOrInfinity = __webpack_require__(63);
var lengthOfArrayLike = __webpack_require__(65);
var doesNotExceedSafeInteger = __webpack_require__(117);
var arraySpeciesCreate = __webpack_require__(119);
var createProperty = __webpack_require__(118);
var deletePropertyOrThrow = __webpack_require__(136);
var arrayMethodHasSpeciesSupport = __webpack_require__(123);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var tryToString = __webpack_require__(40);

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(138);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(139);

module.exports = parent;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(140);
var path = __webpack_require__(32);

module.exports = path.parseFloat;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(10);
var $parseFloat = __webpack_require__(141);

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$({ global: true, forced: parseFloat != $parseFloat }, {
  parseFloat: $parseFloat
});


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var fails = __webpack_require__(15);
var uncurryThis = __webpack_require__(16);
var toString = __webpack_require__(106);
var trim = __webpack_require__(109).trim;
var whitespaces = __webpack_require__(110);

var charAt = uncurryThis(''.charAt);
var n$ParseFloat = global.parseFloat;
var Symbol = global.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var FORCED = 1 / n$ParseFloat(whitespaces + '-0') !== -Infinity
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { n$ParseFloat(Object(ITERATOR)); }));

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
module.exports = FORCED ? function parseFloat(string) {
  var trimmedString = trim(toString(string));
  var result = n$ParseFloat(trimmedString);
  return result === 0 && charAt(trimmedString, 0) == '-' ? -0 : result;
} : n$ParseFloat;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$create = __webpack_require__(143);

var setPrototypeOf = __webpack_require__(154);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = _Object$create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(144);

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(145);


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(146);

module.exports = parent;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(147);

module.exports = parent;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(148);

module.exports = parent;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(149);
var path = __webpack_require__(32);

var Object = path.Object;

module.exports = function create(P, D) {
  return Object.create(P, D);
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
var $ = __webpack_require__(10);
var DESCRIPTORS = __webpack_require__(19);
var create = __webpack_require__(150);

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  create: create
});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(57);
var definePropertiesModule = __webpack_require__(151);
var enumBugKeys = __webpack_require__(68);
var hiddenKeys = __webpack_require__(67);
var html = __webpack_require__(152);
var documentCreateElement = __webpack_require__(51);
var sharedKey = __webpack_require__(153);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(56);
var definePropertyModule = __webpack_require__(55);
var anObject = __webpack_require__(57);
var toIndexedObject = __webpack_require__(23);
var objectKeys = __webpack_require__(59);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(31);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(43);
var uid = __webpack_require__(49);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$setPrototypeOf = __webpack_require__(155);

var _bindInstanceProperty = __webpack_require__(70);

function _setPrototypeOf(o, p) {
  var _context;

  module.exports = _setPrototypeOf = _Object$setPrototypeOf ? _bindInstanceProperty(_context = _Object$setPrototypeOf).call(_context) : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(156);

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(157);


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(158);

module.exports = parent;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(159);

module.exports = parent;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(160);

module.exports = parent;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(161);
var path = __webpack_require__(32);

module.exports = path.Object.setPrototypeOf;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(10);
var setPrototypeOf = __webpack_require__(162);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__(16);
var anObject = __webpack_require__(57);
var aPossiblePrototype = __webpack_require__(163);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__(17);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.whenTransitionend = exports.warn = exports.throttle = exports.switchScrollingEffect = exports.removeClass = exports.query = exports.normalizeProps = exports.noop = exports.moveRecognizer = exports.loadImg = exports.getTransitionDurationFromElement = exports.getStyleValue = exports.getStyleFloatValue = exports.encodeUrl = exports.emulateTransitionEnd = exports.decodeUrl = exports.debounce = exports.btoa = exports.atob = exports.ajax = exports.addClass = exports.EventHandler = exports.EventEmitter = exports.Env = void 0;

var _base = __webpack_require__(167);

exports.noop = _base.noop;
exports.loadImg = _base.loadImg;
exports.warn = _base.warn;

var _style = __webpack_require__(168);

exports.getStyleValue = _style.getStyleValue;
exports.getStyleFloatValue = _style.getStyleFloatValue;

var _recognizer = __webpack_require__(169);

exports.moveRecognizer = _recognizer.moveRecognizer;

var _class = __webpack_require__(171);

exports.addClass = _class.addClass;
exports.removeClass = _class.removeClass;

var _eventHandler = _interopRequireDefault(__webpack_require__(170));

exports.EventHandler = _eventHandler.default;

var _eventEmitter = _interopRequireDefault(__webpack_require__(172));

exports.EventEmitter = _eventEmitter.default;

var _transitionend = __webpack_require__(201);

exports.getTransitionDurationFromElement = _transitionend.getTransitionDurationFromElement;
exports.emulateTransitionEnd = _transitionend.emulateTransitionEnd;
exports.whenTransitionend = _transitionend.whenTransitionend;

var _ajax = _interopRequireDefault(__webpack_require__(202));

exports.ajax = _ajax.default;

var _encode = __webpack_require__(221);

exports.encodeUrl = _encode.encodeUrl;
exports.decodeUrl = _encode.decodeUrl;

var _debounce = _interopRequireDefault(__webpack_require__(222));

exports.debounce = _debounce.default;

var _throttle = _interopRequireDefault(__webpack_require__(237));

exports.throttle = _throttle.default;

var _switchScrollingEffect = _interopRequireDefault(__webpack_require__(238));

exports.switchScrollingEffect = _switchScrollingEffect.default;

var _base2 = __webpack_require__(240);

exports.btoa = _base2.btoa;
exports.atob = _base2.atob;

var _dom = _interopRequireDefault(__webpack_require__(241));

exports.query = _dom.default;

var _env = _interopRequireDefault(__webpack_require__(242));

exports.Env = _env.default;

var _options = __webpack_require__(243);

exports.normalizeProps = _options.normalizeProps;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.noop = exports.loadImg = void 0;
exports.warn = warn;

var noop = function noop() {};

exports.noop = noop;

var loadImg = function loadImg(url, success, error) {
  if (success === void 0) {
    success = noop;
  }

  if (error === void 0) {
    error = noop;
  }

  var img = new Image();
  img.src = url;
  img.onload = success;
  img.onerror = error;
};

exports.loadImg = loadImg;
var hasConsole = typeof console !== 'undefined';

function warn(msg) {
  if (hasConsole) {
    console.error('[Faicaptcha warn]: ' + msg);
  }
}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.getStyleFloatValue = getStyleFloatValue;
exports.getStyleValue = getStyleValue;

var _parseFloat2 = _interopRequireDefault(__webpack_require__(137));

function getComputedStylePixel(element, property, fontSize) {
  element.document; // Internet Explorer sometimes struggles to read currentStyle until the element's document is accessed.

  var value = element.currentStyle[property].match(/([\d\.]+)(%|cm|em|in|mm|pc|pt|)/) || [0, 0, ''],
      size = value[1],
      suffix = value[2],
      rootSize;
  fontSize = !fontSize ? fontSize : /%|em/.test(suffix) && element.parentElement ? getComputedStylePixel(element.parentElement, 'fontSize', null) : 16;
  rootSize = property === 'fontSize' ? fontSize : /width/i.test(property) ? element.clientWidth : element.clientHeight;
  return suffix === '%' ? size / 100 * rootSize : suffix === 'cm' ? size * 0.3937 * 96 : suffix === 'em' ? size * fontSize : suffix === 'in' ? size * 96 : suffix === 'mm' ? size * 0.3937 * 96 / 10 : suffix === 'pc' ? size * 12 * 96 / 72 : suffix === 'pt' ? size * 96 / 72 : size;
}

function setShortStyleProperty(style, property) {
  var borderSuffix = property === 'border' ? 'Width' : '',
      t = property + 'Top' + borderSuffix,
      r = property + 'Right' + borderSuffix,
      b = property + 'Bottom' + borderSuffix,
      l = property + 'Left' + borderSuffix;
  style[property] = (style[t] === style[r] && style[t] === style[b] && style[t] === style[l] ? [style[t]] : style[t] === style[b] && style[l] === style[r] ? [style[t], style[r]] : style[l] === style[r] ? [style[t], style[r], style[b]] : [style[t], style[r], style[b], style[l]]).join(' ');
} // <CSSStyleDeclaration>


function CSSStyleDeclaration(element) {
  var style = this,
      currentStyle = element.currentStyle,
      fontSize = getComputedStylePixel(element, 'fontSize'),
      unCamelCase = function unCamelCase(match) {
    return '-' + match.toLowerCase();
  },
      property;

  for (property in currentStyle) {
    Array.prototype.push.call(style, property === 'styleFloat' ? 'float' : property.replace(/[A-Z]/, unCamelCase));

    if (property === 'width') {
      style[property] = element.offsetWidth + 'px';
    } else if (property === 'height') {
      style[property] = element.offsetHeight + 'px';
    } else if (property === 'styleFloat') {
      style.float = currentStyle[property];
    } else if (/margin.|padding.|border.+W/.test(property) && style[property] !== 'auto') {
      style[property] = Math.round(getComputedStylePixel(element, property, fontSize)) + 'px';
    } else if (/^outline/.test(property)) {
      // errors on checking outline
      try {
        style[property] = currentStyle[property];
      } catch (error) {
        style.outlineColor = currentStyle.color;
        style.outlineStyle = style.outlineStyle || 'none';
        style.outlineWidth = style.outlineWidth || '0px';
        style.outline = [style.outlineColor, style.outlineWidth, style.outlineStyle].join(' ');
      }
    } else {
      style[property] = currentStyle[property];
    }
  }

  setShortStyleProperty(style, 'margin');
  setShortStyleProperty(style, 'padding');
  setShortStyleProperty(style, 'border');
  style.fontSize = Math.round(fontSize) + 'px';
}

CSSStyleDeclaration.prototype = {
  constructor: CSSStyleDeclaration,
  // <CSSStyleDeclaration>.getPropertyPriority
  getPropertyPriority: function getPropertyPriority() {
    throw new Error('NotSupportedError: DOM Exception 9');
  },
  // <CSSStyleDeclaration>.getPropertyValue
  getPropertyValue: function getPropertyValue(property) {
    return this[property.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    })];
  },
  // <CSSStyleDeclaration>.item
  item: function item(index) {
    return this[index];
  },
  // <CSSStyleDeclaration>.removeProperty
  removeProperty: function removeProperty() {
    throw new Error('NoModificationAllowedError: DOM Exception 7');
  },
  // <CSSStyleDeclaration>.setProperty
  setProperty: function setProperty() {
    throw new Error('NoModificationAllowedError: DOM Exception 7');
  },
  // <CSSStyleDeclaration>.getPropertyCSSValue
  getPropertyCSSValue: function getPropertyCSSValue() {
    throw new Error('NotSupportedError: DOM Exception 9');
  }
};
/**
Returns a given computed style of a DOM element.

@method getStyle
@static
@param {Object} obj DOM element like object.
@param {String} name Style you want to get from the DOM element
*/

var getStyle = function getStyle(obj, name) {
  if (window.getComputedStyle) {
    return window.getComputedStyle(obj, null)[name];
  } else {
    return new CSSStyleDeclaration(obj)[name];
  }
};

function getStyleValue(elt, property) {
  return getStyle(elt, property);
}

function getStyleFloatValue(elt, property) {
  return (0, _parseFloat2.default)(getStyleValue(elt, property), 10);
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.moveRecognizer = moveRecognizer;

var _eventHandler = _interopRequireDefault(__webpack_require__(170));

function moveRecognizer(elt, initalization) {
  function onMoveStart(e) {
    e = e.targetTouches ? e.targetTouches[0] : e || window.event;
    var ret = initalization.call(this, e);
    if (!ret) return;
    var handleMoving = ret[0],
        handleMoveEnd = ret[1];

    function onMoving(e) {
      e = e.targetTouches ? e.targetTouches[0] : e || window.event;
      handleMoving.call(this, e);
    }

    function onMoveEnd(e) {
      e = e.changedTouches ? e.changedTouches[0] : e || window.event;
      handleMoveEnd.call(this, e);

      _eventHandler.default.off(document, 'mousemove', onMoving);

      _eventHandler.default.off(document, 'mouseup', onMoveEnd);

      _eventHandler.default.off(document, 'touchmove', onMoving);

      _eventHandler.default.off(document, 'touchend', onMoveEnd);
    }

    _eventHandler.default.on(document, 'mousemove', onMoving);

    _eventHandler.default.on(document, 'mouseup', onMoveEnd);

    _eventHandler.default.on(document, 'touchmove', onMoving);

    _eventHandler.default.on(document, 'touchend', onMoveEnd);
  }

  _eventHandler.default.on(elt, 'mousedown', onMoveStart);

  _eventHandler.default.on(elt, 'touchstart', onMoveStart);

  var unstallMoveRecognizer = function unstallMoveRecognizer() {
    _eventHandler.default.off(elt, 'mousedown', onMoveStart);

    _eventHandler.default.off(elt, 'touchstart', onMoveStart);
  };

  return unstallMoveRecognizer;
}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _splice = _interopRequireDefault(__webpack_require__(131));

/**
Generates an unique ID. The only way a user would be able to get the same ID is if the two persons
at the same exact millisecond manage to get the same 5 random numbers between 0-65535; it also uses
a counter so each ID is guaranteed to be unique for the given page. It is more probable for the earth
to be hit with an asteroid.

@method guid
@static
@param {String} prefix to prepend (by default 'o' will be prepended).
@method guid
@return {String} Virtually unique id.
*/
var guid = function () {
  var counter = 0;
  return function (prefix) {
    var guid = new Date().getTime().toString(32),
        i;

    for (i = 0; i < 5; i++) {
      guid += Math.floor(Math.random() * 65535).toString(32);
    }

    return (prefix || 'o_') + guid + (counter++).toString(32);
  };
}();
/**
Gets the true type of the built-in object (better version of typeof).
@author Angus Croll (http://javascriptweblog.wordpress.com/)

@method typeOf
@static
@param {Object} o Object to check.
@return {String} Object [[Class]]
*/


function typeOf(o) {
  var undef;

  if (o === undef) {
    return 'undefined';
  } else if (o === null) {
    return 'null';
  } else if (o.nodeType) {
    return 'node';
  } // the snippet below is awesome, however it fails to detect null, undefined and arguments types in IE lte 8


  return {}.toString.call(o).match(/\s([a-z|A-Z]+)/)[1].toLowerCase();
}
/**
Checks if object is empty.

@method isEmptyObj
@static
@param {Object} o Object to check.
@return {Boolean}
*/


function isEmptyObj(obj) {
  var prop;

  if (!obj || typeOf(obj) !== 'object') {
    return true;
  }

  for (prop in obj) {
    return false;
  }

  return true;
}

var eventhash = {},
    uid = 'faicaptcha_' + guid(); // IE W3C like event funcs

function preventDefault() {
  this.returnValue = false;
}

function stopPropagation() {
  this.cancelBubble = true;
}
/**
Adds an event handler to the specified object and store reference to the handler
in objects internal Plupload registry (@see removeEvent).

@method addEvent
@static
@param {Object} obj DOM element like object to add handler to.
@param {String} name Name to add event listener to.
@param {Function} callback Function to call when event occurs.
@param {String} [key] that might be used to add specifity to the event record.
*/


var addEvent = function addEvent(obj, name, callback, key) {
  var func, events;
  name = name.toLowerCase(); // Add event listener

  if (obj.addEventListener) {
    func = callback;
    obj.addEventListener(name, func, false);
  } else if (obj.attachEvent) {
    func = function func() {
      var evt = window.event;

      if (!evt.target) {
        evt.target = evt.srcElement;
      }

      evt.preventDefault = preventDefault;
      evt.stopPropagation = stopPropagation;
      callback(evt);
    };

    obj.attachEvent('on' + name, func);
  } // Log event handler to objects internal mOxie registry


  if (!obj[uid]) {
    obj[uid] = guid();
  }

  if (!eventhash.hasOwnProperty(obj[uid])) {
    eventhash[obj[uid]] = {};
  }

  events = eventhash[obj[uid]];

  if (!events.hasOwnProperty(name)) {
    events[name] = [];
  }

  events[name].push({
    func: func,
    orig: callback,
    // store original callback for IE
    key: key
  });
};
/**
Remove event handler from the specified object. If third argument (callback)
is not specified remove all events with the specified name.

@method removeEvent
@static
@param {Object} obj DOM element to remove event listener(s) from.
@param {String} name Name of event listener to remove.
@param {Function|String} [callback] might be a callback or unique key to match.
*/


var removeEvent = function removeEvent(obj, name, callback) {
  var type, undef;
  name = name.toLowerCase();

  if (obj[uid] && eventhash[obj[uid]] && eventhash[obj[uid]][name]) {
    type = eventhash[obj[uid]][name];
  } else {
    return;
  }

  for (var i = type.length - 1; i >= 0; i--) {
    // undefined or not, key should match
    if (type[i].orig === callback || type[i].key === callback) {
      if (obj.removeEventListener) {
        obj.removeEventListener(name, type[i].func, false);
      } else if (obj.detachEvent) {
        obj.detachEvent('on' + name, type[i].func);
      }

      type[i].orig = null;
      type[i].func = null;
      (0, _splice.default)(type).call(type, i, 1); // If callback was passed we are done here, otherwise proceed

      if (callback !== undef) {
        break;
      }
    }
  } // If event array got empty, remove it


  if (!type.length) {
    delete eventhash[obj[uid]][name];
  } // If mOxie registry has become empty, remove it


  if (isEmptyObj(eventhash[obj[uid]])) {
    delete eventhash[obj[uid]]; // IE doesn't let you remove DOM object property with - delete

    try {
      delete obj[uid];
    } catch (e) {
      obj[uid] = undef;
    }
  }
};

function on(elt, type, listener) {
  addEvent(elt, type, listener);
}

function off(elt, type, listener) {
  removeEvent(elt, type, listener);
}

function one(elt, type, listener) {
  function _listener() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listener.apply(this, args);
    off(elt, type, _listener);
  }

  on(elt, type, _listener);
}

var EventHandler = {
  on: on,
  off: off,
  one: one
};
var _default = EventHandler;
exports.default = _default;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.removeClass = exports.hasClass = exports.addClass = void 0;

/**
	Checks if specified DOM element has specified class.

	@method hasClass
	@static
	@param {Object} obj DOM element like object to add handler to.
	@param {String} name Class name
	*/
var hasClass = function hasClass(obj, name) {
  if (!obj.className) {
    return false;
  }

  var regExp = new RegExp('(^|\\s+)' + name + '(\\s+|$)');
  return regExp.test(obj.className);
};
/**
	Adds specified className to specified DOM element.

	@method addClass
	@static
	@param {Object} obj DOM element like object to add handler to.
	@param {String} name Class name
	*/


exports.hasClass = hasClass;

var addClass = function addClass(obj, name) {
  if (!hasClass(obj, name)) {
    obj.className = !obj.className ? name : obj.className.replace(/\s+$/, '') + ' ' + name;
  }
};
/**
	Removes specified className from specified DOM element.

	@method removeClass
	@static
	@param {Object} obj DOM element like object to add handler to.
	@param {String} name Class name
	*/


exports.addClass = addClass;

var removeClass = function removeClass(obj, name) {
  if (obj.className) {
    var regExp = new RegExp('(^|\\s+)' + name + '(\\s+|$)');
    obj.className = obj.className.replace(regExp, function ($0, $1, $2) {
      return $1 === ' ' && $2 === ' ' ? ' ' : '';
    });
  }
};

exports.removeClass = removeClass;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _create = _interopRequireDefault(__webpack_require__(173));

var _slice = _interopRequireDefault(__webpack_require__(174));

var _getOwnPropertySymbols = _interopRequireDefault(__webpack_require__(179));

var _concat = _interopRequireDefault(__webpack_require__(111));

var has = Object.prototype.hasOwnProperty,
    prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */

function Events() {} //
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//


if (_create.default) {
  Events.prototype = (0, _create.default)(null); //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //

  if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */


function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */


function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once),
      evt = prefix ? prefix + event : event;
  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);else emitter._events[evt] = [emitter._events[evt], listener];
  return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */


function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */


function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */


EventEmitter.prototype.eventNames = function eventNames() {
  var names = [],
      events,
      name;
  if (this._eventsCount === 0) return names;

  for (name in events = this._events) {
    if (has.call(events, name)) names.push(prefix ? (0, _slice.default)(name).call(name, 1) : name);
  }

  if (_getOwnPropertySymbols.default) {
    return (0, _concat.default)(names).call(names, (0, _getOwnPropertySymbols.default)(events));
  }

  return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */


EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event,
      handlers = this._events[evt];
  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */


EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event,
      listeners = this._events[evt];
  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */


EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;
  if (!this._events[evt]) return false;
  var listeners = this._events[evt],
      len = arguments.length,
      args,
      i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1:
        return listeners.fn.call(listeners.context), true;

      case 2:
        return listeners.fn.call(listeners.context, a1), true;

      case 3:
        return listeners.fn.call(listeners.context, a1, a2), true;

      case 4:
        return listeners.fn.call(listeners.context, a1, a2, a3), true;

      case 5:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;

      case 6:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len - 1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length,
        j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1:
          listeners[i].fn.call(listeners[i].context);
          break;

        case 2:
          listeners[i].fn.call(listeners[i].context, a1);
          break;

        case 3:
          listeners[i].fn.call(listeners[i].context, a1, a2);
          break;

        case 4:
          listeners[i].fn.call(listeners[i].context, a1, a2, a3);
          break;

        default:
          if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
            args[j - 1] = arguments[j];
          }
          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */


EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */


EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */


EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;
  if (!this._events[evt]) return this;

  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
        events.push(listeners[i]);
      }
    } //
    // Reset the array, or remove it completely if we have no more listeners.
    //


    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else clearEvent(this, evt);
  }

  return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */


EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
}; //
// Alias methods names because people roll like that.
//


EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on; //
// Expose the prefix.
//

EventEmitter.prefixed = prefix; //
// Allow `EventEmitter` to be imported as module namespace.
//

EventEmitter.EventEmitter = EventEmitter; //
// Expose the module.
//

if (true) {
  module.exports = EventEmitter;
}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(147);

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(175);

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(176);

module.exports = parent;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(33);
var method = __webpack_require__(177);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.slice;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.slice) ? method : own;
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(178);
var entryVirtual = __webpack_require__(80);

module.exports = entryVirtual('Array').slice;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(10);
var isArray = __webpack_require__(116);
var isConstructor = __webpack_require__(121);
var isObject = __webpack_require__(29);
var toAbsoluteIndex = __webpack_require__(62);
var lengthOfArrayLike = __webpack_require__(65);
var toIndexedObject = __webpack_require__(23);
var createProperty = __webpack_require__(118);
var wellKnownSymbol = __webpack_require__(42);
var arrayMethodHasSpeciesSupport = __webpack_require__(123);
var un$Slice = __webpack_require__(79);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return un$Slice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(180);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(181);

module.exports = parent;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(182);
var path = __webpack_require__(32);

module.exports = path.Object.getOwnPropertySymbols;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(183);
__webpack_require__(196);
__webpack_require__(198);
__webpack_require__(199);
__webpack_require__(200);


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(10);
var global = __webpack_require__(11);
var call = __webpack_require__(20);
var uncurryThis = __webpack_require__(16);
var IS_PURE = __webpack_require__(44);
var DESCRIPTORS = __webpack_require__(19);
var NATIVE_SYMBOL = __webpack_require__(35);
var fails = __webpack_require__(15);
var hasOwn = __webpack_require__(47);
var isPrototypeOf = __webpack_require__(33);
var anObject = __webpack_require__(57);
var toIndexedObject = __webpack_require__(23);
var toPropertyKey = __webpack_require__(27);
var $toString = __webpack_require__(106);
var createPropertyDescriptor = __webpack_require__(22);
var nativeObjectCreate = __webpack_require__(150);
var objectKeys = __webpack_require__(59);
var getOwnPropertyNamesModule = __webpack_require__(184);
var getOwnPropertyNamesExternal = __webpack_require__(185);
var getOwnPropertySymbolsModule = __webpack_require__(69);
var getOwnPropertyDescriptorModule = __webpack_require__(18);
var definePropertyModule = __webpack_require__(55);
var definePropertiesModule = __webpack_require__(151);
var propertyIsEnumerableModule = __webpack_require__(21);
var defineBuiltIn = __webpack_require__(187);
var shared = __webpack_require__(43);
var sharedKey = __webpack_require__(153);
var hiddenKeys = __webpack_require__(67);
var uid = __webpack_require__(49);
var wellKnownSymbol = __webpack_require__(42);
var wrappedWellKnownSymbolModule = __webpack_require__(188);
var defineWellKnownSymbol = __webpack_require__(189);
var defineSymbolToPrimitive = __webpack_require__(190);
var setToStringTag = __webpack_require__(191);
var InternalStateModule = __webpack_require__(193);
var $forEach = __webpack_require__(195).forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(60);
var enumBugKeys = __webpack_require__(68);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es-x/no-object-getownpropertynames -- safe */
var classof = __webpack_require__(25);
var toIndexedObject = __webpack_require__(23);
var $getOwnPropertyNames = __webpack_require__(184).f;
var arraySlice = __webpack_require__(186);

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var toAbsoluteIndex = __webpack_require__(62);
var lengthOfArrayLike = __webpack_require__(65);
var createProperty = __webpack_require__(118);

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var createNonEnumerableProperty = __webpack_require__(54);

module.exports = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty(target, key, value);
  return target;
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(42);

exports.f = wellKnownSymbol;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(32);
var hasOwn = __webpack_require__(47);
var wrappedWellKnownSymbolModule = __webpack_require__(188);
var defineProperty = __webpack_require__(55).f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__(20);
var getBuiltIn = __webpack_require__(31);
var wellKnownSymbol = __webpack_require__(42);
var defineBuiltIn = __webpack_require__(187);

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(108);
var defineProperty = __webpack_require__(55).f;
var createNonEnumerableProperty = __webpack_require__(54);
var hasOwn = __webpack_require__(47);
var toString = __webpack_require__(192);
var wellKnownSymbol = __webpack_require__(42);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    if (!hasOwn(target, TO_STRING_TAG)) {
      defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !TO_STRING_TAG_SUPPORT) {
      createNonEnumerableProperty(target, 'toString', toString);
    }
  }
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(108);
var classof = __webpack_require__(107);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(194);
var global = __webpack_require__(11);
var uncurryThis = __webpack_require__(16);
var isObject = __webpack_require__(29);
var createNonEnumerableProperty = __webpack_require__(54);
var hasOwn = __webpack_require__(47);
var shared = __webpack_require__(45);
var sharedKey = __webpack_require__(153);
var hiddenKeys = __webpack_require__(67);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var isCallable = __webpack_require__(17);
var inspectSource = __webpack_require__(122);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(53);
var uncurryThis = __webpack_require__(16);
var IndexedObject = __webpack_require__(24);
var toObject = __webpack_require__(48);
var lengthOfArrayLike = __webpack_require__(65);
var arraySpeciesCreate = __webpack_require__(119);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(10);
var getBuiltIn = __webpack_require__(31);
var hasOwn = __webpack_require__(47);
var toString = __webpack_require__(106);
var shared = __webpack_require__(43);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(197);

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__(35);

/* eslint-disable es-x/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(10);
var hasOwn = __webpack_require__(47);
var isSymbol = __webpack_require__(30);
var tryToString = __webpack_require__(40);
var shared = __webpack_require__(43);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(197);

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(10);
var getBuiltIn = __webpack_require__(31);
var apply = __webpack_require__(13);
var call = __webpack_require__(20);
var uncurryThis = __webpack_require__(16);
var fails = __webpack_require__(15);
var isArray = __webpack_require__(116);
var isCallable = __webpack_require__(17);
var isObject = __webpack_require__(29);
var isSymbol = __webpack_require__(30);
var arraySlice = __webpack_require__(79);
var NATIVE_SYMBOL = __webpack_require__(35);

var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')();
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) != '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) != '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = replacer;
  if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
  if (!isArray(replacer)) replacer = function (key, value) {
    if (isCallable($replacer)) value = call($replacer, this, key, value);
    if (!isSymbol(value)) return value;
  };
  args[1] = replacer;
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(10);
var NATIVE_SYMBOL = __webpack_require__(35);
var fails = __webpack_require__(15);
var getOwnPropertySymbolsModule = __webpack_require__(69);
var toObject = __webpack_require__(48);

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.whenTransitionend = exports.getTransitionDurationFromElement = exports.emulateTransitionEnd = void 0;

var _parseFloat2 = _interopRequireDefault(__webpack_require__(137));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(124));

var _eventHandler = _interopRequireDefault(__webpack_require__(170));

var TRANSITION_END = 'transitionend';

var getTransitionDurationFromElement = function getTransitionDurationFromElement(element) {
  if (!element) {
    return 0;
  } // Get transition-duration of the element


  var _window$getComputedSt = window.getComputedStyle(element),
      transitionDuration = _window$getComputedSt.transitionDuration,
      transitionDelay = _window$getComputedSt.transitionDelay;

  var floatTransitionDuration = (0, _parseFloat2.default)(transitionDuration);
  var floatTransitionDelay = (0, _parseFloat2.default)(transitionDelay); // Return 0 if element or transition duration is not found

  if (!floatTransitionDuration && !floatTransitionDelay) {
    return 0;
  } // If multiple durations are defined, take the first


  transitionDuration = transitionDuration.split(',')[0];
  transitionDelay = transitionDelay.split(',')[0];
  return ((0, _parseFloat2.default)(transitionDuration) + (0, _parseFloat2.default)(transitionDelay)) * 1000;
};

exports.getTransitionDurationFromElement = getTransitionDurationFromElement;

var triggerTransitionEnd = function triggerTransitionEnd(element) {
  var evt = document.createEvent('HTMLEvents');
  evt.initEvent(TRANSITION_END, true, true);
  element.dispatchEvent(evt);
};

var emulateTransitionEnd = function emulateTransitionEnd(element, duration) {
  var called = false;
  var durationPadding = 5;
  var emulatedDuration = duration + durationPadding;

  function listener() {
    called = true;

    _eventHandler.default.off(element, TRANSITION_END, listener);
  }

  _eventHandler.default.on(element, TRANSITION_END, listener);

  (0, _setTimeout2.default)(function () {
    if (!called) {
      triggerTransitionEnd(element);
    }
  }, emulatedDuration);
};

exports.emulateTransitionEnd = emulateTransitionEnd;

var whenTransitionend = function whenTransitionend(element, cb) {
  _eventHandler.default.one(element, 'transitionend', function () {
    cb && cb();
  });

  var duration = getTransitionDurationFromElement(element);
  emulateTransitionEnd(element, duration);
};

exports.whenTransitionend = whenTransitionend;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _slice = _interopRequireDefault(__webpack_require__(174));

var _indexOf = _interopRequireDefault(__webpack_require__(203));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(124));

var _forEach = _interopRequireDefault(__webpack_require__(204));

var type = function type(temp) {
  var _context;

  return (0, _slice.default)(_context = Object.prototype.toString.call(temp)).call(_context, 8, -1).toLowerCase();
}; // For IE 8/9 CORS support
// Only supports POST and GET calls and doesn't returns the response headers.


var xDomain = function () {
  var request = new XMLHttpRequest();

  if (typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request)) {
    return true;
  } else {
    return false;
  }
}();

var jsonpID = 0,
    document = window.document,
    key,
    name,
    rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
    scriptTypeRE = /^(?:text|application)\/javascript/i,
    xmlTypeRE = /^(?:text|application)\/xml/i,
    jsonType = 'application/json',
    htmlType = 'text/html',
    blankRE = /^\s*$/,
    loadEvent = xDomain ? 'onload' : 'onreadystatechange';

var ajax = module.exports = function (options) {
  var settings = extend({}, options || {});

  for (key in ajax.settings) {
    if (settings[key] === undefined) settings[key] = ajax.settings[key];
  }

  ajaxStart(settings);
  if (!settings.crossDomain) settings.crossDomain = /^([\w-]+:)?\/\/([^\/]+)/.test(settings.url) && RegExp.$2 != window.location.host;
  var dataType = settings.dataType,
      hasPlaceholder = /=\?/.test(settings.url);

  if (dataType == 'jsonp' || hasPlaceholder) {
    if (!hasPlaceholder) settings.url = appendQuery(settings.url, 'callback=?');
    return ajax.JSONP(settings);
  }

  if (!settings.url) settings.url = window.location.toString();
  serializeData(settings);
  var mime = settings.accepts[dataType],
      baseHeaders = {},
      protocol = /^([\w-]+:)\/\//.test(settings.url) ? RegExp.$1 : window.location.protocol,
      xhr = ajax.settings.xhr(),
      abortTimeout;
  if (!settings.crossDomain) baseHeaders['X-Requested-With'] = 'XMLHttpRequest';

  if (mime) {
    baseHeaders['Accept'] = mime;
    if ((0, _indexOf.default)(mime).call(mime, ',') > -1) mime = mime.split(',', 2)[0];
    xhr.overrideMimeType && xhr.overrideMimeType(mime);
  }

  if (settings.contentType || settings.data && settings.type.toUpperCase() != 'GET') baseHeaders['Content-Type'] = settings.contentType || 'application/x-www-form-urlencoded';
  settings.headers = extend(baseHeaders, settings.headers || {});

  xhr[loadEvent] = function () {
    if (xhr.readyState == 4 || xDomain) {
      clearTimeout(abortTimeout);
      var result,
          error = false;

      if (!xhr.status || xhr.status >= 200 && xhr.status < 300 || xhr.status == 304 || xhr.status == 0 && protocol == 'file:') {
        dataType = dataType || mimeToDataType('getResponseHeader' in xhr ? xhr.getResponseHeader('content-type') : null);
        result = xhr.responseText;

        try {
          if (dataType == 'script') (1, eval)(result);else if (dataType == 'xml') result = xhr.responseXML;else if (dataType == 'json') result = blankRE.test(result) ? null : JSON.parse(result);
        } catch (e) {
          error = e;
        }

        if (error) ajaxError(error, 'parsererror', xhr, settings);else ajaxSuccess(result, xhr, settings);
      } else {
        ajaxError(null, 'error', xhr, settings);
      }
    }
  };

  var async = 'async' in settings ? settings.async : true;
  xhr.open(settings.type, settings.url, async);

  if ('setRequestHeader' in xhr) {
    for (name in settings.headers) {
      xhr.setRequestHeader(name, settings.headers[name]);
    }
  }

  if (ajaxBeforeSend(xhr, settings) === false) {
    xhr.abort();
    return false;
  }

  if (settings.timeout > 0) abortTimeout = (0, _setTimeout2.default)(function () {
    xhr.onreadystatechange = empty;
    xhr.abort();
    ajaxError(null, 'timeout', xhr, settings);
  }, settings.timeout); // avoid sending empty string (#319)

  xhr.send(settings.data ? settings.data : null);
  return xhr;
}; // trigger a custom event and return false if it was cancelled


function triggerAndReturn(context, eventName, data) {
  //todo: Fire off some events
  //var event = $.Event(eventName)
  //$(context).trigger(event, data)
  return true; //!event.defaultPrevented
} // trigger an Ajax "global" event


function triggerGlobal(settings, context, eventName, data) {
  if (settings.global) return triggerAndReturn(context || document, eventName, data);
} // Number of active Ajax requests


ajax.active = 0;

function ajaxStart(settings) {
  if (settings.global && ajax.active++ === 0) triggerGlobal(settings, null, 'ajaxStart');
}

function ajaxStop(settings) {
  if (settings.global && ! --ajax.active) triggerGlobal(settings, null, 'ajaxStop');
} // triggers an extra global event "ajaxBeforeSend" that's like "ajaxSend" but cancelable


function ajaxBeforeSend(xhr, settings) {
  var context = settings.context;
  if (settings.beforeSend.call(context, xhr, settings) === false || triggerGlobal(settings, context, 'ajaxBeforeSend', [xhr, settings]) === false) return false;
  triggerGlobal(settings, context, 'ajaxSend', [xhr, settings]);
}

function ajaxSuccess(data, xhr, settings) {
  var context = settings.context,
      status = 'success';
  settings.success.call(context, data, status, xhr);
  triggerGlobal(settings, context, 'ajaxSuccess', [xhr, settings, data]);
  ajaxComplete(status, xhr, settings);
} // type: "timeout", "error", "abort", "parsererror"


function ajaxError(error, type, xhr, settings) {
  var context = settings.context;
  settings.error.call(context, xhr, type, error);
  triggerGlobal(settings, context, 'ajaxError', [xhr, settings, error]);
  ajaxComplete(type, xhr, settings);
} // status: "success", "notmodified", "error", "timeout", "abort", "parsererror"


function ajaxComplete(status, xhr, settings) {
  var context = settings.context;
  settings.complete.call(context, xhr, status);
  triggerGlobal(settings, context, 'ajaxComplete', [xhr, settings]);
  ajaxStop(settings);
} // Empty function, used as default callback


function empty() {}

ajax.JSONP = function (options) {
  if (!('type' in options)) return ajax(options);

  var callbackName = 'jsonp' + ++jsonpID,
      script = document.createElement('script'),
      abort = function abort() {
    //todo: remove script
    //$(script).remove()
    if (callbackName in window) window[callbackName] = empty;
    ajaxComplete('abort', xhr, options);
  },
      xhr = {
    abort: abort
  },
      abortTimeout,
      head = document.getElementsByTagName('head')[0] || document.documentElement;

  if (options.error) script.onerror = function () {
    xhr.abort();
    options.error();
  };

  window[callbackName] = function (data) {
    clearTimeout(abortTimeout); //todo: remove script
    //$(script).remove()

    delete window[callbackName];
    ajaxSuccess(data, xhr, options);
  };

  serializeData(options);
  script.src = options.url.replace(/=\?/, '=' + callbackName); // Use insertBefore instead of appendChild to circumvent an IE6 bug.
  // This arises when a base node is used (see jQuery bugs #2709 and #4378).

  head.insertBefore(script, head.firstChild);
  if (options.timeout > 0) abortTimeout = (0, _setTimeout2.default)(function () {
    xhr.abort();
    ajaxComplete('timeout', xhr, options);
  }, options.timeout);
  return xhr;
};

ajax.settings = {
  // Default type of request
  type: 'GET',
  // Callback that is executed before request
  beforeSend: empty,
  // Callback that is executed if the request succeeds
  success: empty,
  // Callback that is executed the the server drops error
  error: empty,
  // Callback that is executed on request complete (both: error and success)
  complete: empty,
  // The context for the callbacks
  context: null,
  // Whether to trigger "global" Ajax events
  global: true,
  // Transport
  xhr: function xhr() {
    var xhr = new window.XMLHttpRequest(); // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.

    if (xDomain) {
      xhr = new window.XDomainRequest();
    }

    return xhr;
  },
  // MIME types mapping
  accepts: {
    script: 'text/javascript, application/javascript',
    json: jsonType,
    xml: 'application/xml, text/xml',
    html: htmlType,
    text: 'text/plain'
  },
  // Whether the request is to another domain
  crossDomain: false,
  // Default timeout
  timeout: 0
};

function mimeToDataType(mime) {
  return mime && (mime == htmlType ? 'html' : mime == jsonType ? 'json' : scriptTypeRE.test(mime) ? 'script' : xmlTypeRE.test(mime) && 'xml') || 'text';
}

function appendQuery(url, query) {
  return (url + '&' + query).replace(/[&?]{1,2}/, '?');
} // serialize payload and append it to the URL for GET requests


function serializeData(options) {
  if (type(options.data) === 'object') options.data = param(options.data);
  if (options.data && (!options.type || options.type.toUpperCase() == 'GET')) options.url = appendQuery(options.url, options.data);
}

ajax.get = function (url, success) {
  return ajax({
    url: url,
    success: success
  });
};

ajax.post = function (url, data, success, dataType) {
  if (type(data) === 'function') dataType = dataType || success, success = data, data = null;
  return ajax({
    type: 'POST',
    url: url,
    data: data,
    success: success,
    dataType: dataType
  });
};

ajax.getJSON = function (url, success) {
  return ajax({
    url: url,
    success: success,
    dataType: 'json'
  });
};

var escape = encodeURIComponent;

function serialize(params, obj, traditional, scope) {
  var array = type(obj) === 'array';

  for (var key in obj) {
    var value = obj[key];
    if (scope) key = traditional ? scope : scope + '[' + (array ? '' : key) + ']'; // handle data in serializeArray() format

    if (!scope && array) params.add(value.name, value.value); // recurse into nested objects
    else if (traditional ? type(value) === 'array' : type(value) === 'object') serialize(params, value, traditional, key);else params.add(key, value);
  }
}

function param(obj, traditional) {
  var params = [];

  params.add = function (k, v) {
    this.push(escape(k) + '=' + escape(v));
  };

  serialize(params, obj, traditional);
  return params.join('&').replace('%20', '+');
}

function extend(target) {
  var _context2;

  var slice = (0, _slice.default)(Array.prototype);
  (0, _forEach.default)(_context2 = slice.call(arguments, 1)).call(_context2, function (source) {
    for (key in source) {
      if (source[key] !== undefined) target[key] = source[key];
    }
  });
  return target;
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(95);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(205);

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(206);
var classof = __webpack_require__(107);
var hasOwn = __webpack_require__(47);
var isPrototypeOf = __webpack_require__(33);
var method = __webpack_require__(217);

var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

module.exports = function (it) {
  var own = it.forEach;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.forEach)
    || hasOwn(DOMIterables, classof(it)) ? method : own;
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(207);
var DOMIterables = __webpack_require__(216);
var global = __webpack_require__(11);
var classof = __webpack_require__(107);
var createNonEnumerableProperty = __webpack_require__(54);
var Iterators = __webpack_require__(209);
var wellKnownSymbol = __webpack_require__(42);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG) {
    createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
  }
  Iterators[COLLECTION_NAME] = Iterators.Array;
}


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(23);
var addToUnscopables = __webpack_require__(208);
var Iterators = __webpack_require__(209);
var InternalStateModule = __webpack_require__(193);
var defineProperty = __webpack_require__(55).f;
var defineIterator = __webpack_require__(210);
var IS_PURE = __webpack_require__(44);
var DESCRIPTORS = __webpack_require__(19);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(10);
var call = __webpack_require__(20);
var IS_PURE = __webpack_require__(44);
var FunctionName = __webpack_require__(211);
var isCallable = __webpack_require__(17);
var createIteratorConstructor = __webpack_require__(212);
var getPrototypeOf = __webpack_require__(214);
var setPrototypeOf = __webpack_require__(162);
var setToStringTag = __webpack_require__(191);
var createNonEnumerableProperty = __webpack_require__(54);
var defineBuiltIn = __webpack_require__(187);
var wellKnownSymbol = __webpack_require__(42);
var Iterators = __webpack_require__(209);
var IteratorsCore = __webpack_require__(213);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var hasOwn = __webpack_require__(47);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(213).IteratorPrototype;
var create = __webpack_require__(150);
var createPropertyDescriptor = __webpack_require__(22);
var setToStringTag = __webpack_require__(191);
var Iterators = __webpack_require__(209);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(15);
var isCallable = __webpack_require__(17);
var create = __webpack_require__(150);
var getPrototypeOf = __webpack_require__(214);
var defineBuiltIn = __webpack_require__(187);
var wellKnownSymbol = __webpack_require__(42);
var IS_PURE = __webpack_require__(44);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es-x/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__(47);
var isCallable = __webpack_require__(17);
var toObject = __webpack_require__(48);
var sharedKey = __webpack_require__(153);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(215);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(15);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 216 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(218);

module.exports = parent;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(219);
var entryVirtual = __webpack_require__(80);

module.exports = entryVirtual('Array').forEach;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(10);
var forEach = __webpack_require__(220);

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es-x/no-array-prototype-foreach -- safe
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(195).forEach;
var arrayMethodIsStrict = __webpack_require__(99);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es-x/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.encodeUrl = exports.decodeUrl = void 0;

var encodeUrl = function encodeUrl(uri) {
  return typeof uri === 'undefined' ? '' : encodeURIComponent(uri);
};

exports.encodeUrl = encodeUrl;

var decodeUrl = function decodeUrl(uri) {
  return typeof uri === 'undefined' ? '' : decodeURIComponent(uri);
};

exports.decodeUrl = decodeUrl;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _setTimeout2 = _interopRequireDefault(__webpack_require__(124));

var _now = _interopRequireDefault(__webpack_require__(223));

var _isObject = _interopRequireDefault(__webpack_require__(227));

var _root = _interopRequireDefault(__webpack_require__(228));

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked, or until the next browser frame is drawn. The debounced function
 * comes with a `cancel` method to cancel delayed `func` invocations and a
 * `flush` method to immediately invoke them. Provide `options` to indicate
 * whether `func` should be invoked on the leading and/or trailing edge of the
 * `wait` timeout. The `func` is invoked with the last arguments provided to the
 * debounced function. Subsequent calls to the debounced function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * If `wait` is omitted in an environment with `requestAnimationFrame`, `func`
 * invocation will be deferred until the next frame is drawn (typically about
 * 16ms).
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `debounce` and `throttle`.
 *
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0]
 *  The number of milliseconds to delay; if omitted, `requestAnimationFrame` is
 *  used (if available).
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', debounce(calculateLayout, 150))
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }))
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * const debounced = debounce(batchLog, 250, { 'maxWait': 1000 })
 * const source = new EventSource('/stream')
 * jQuery(source).on('message', debounced)
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel)
 *
 * // Check for pending invocations.
 * const status = debounced.pending() ? "Pending..." : "Ready"
 */
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime;
  var lastInvokeTime = 0;
  var leading = false;
  var maxing = false;
  var trailing = true; // Bypass `requestAnimationFrame` by explicitly setting `wait=0`.

  var useRAF = !wait && wait !== 0 && typeof _root.default.requestAnimationFrame === 'function';

  if (typeof func !== 'function') {
    throw new TypeError('Expected a function');
  }

  wait = +wait || 0;

  if ((0, _isObject.default)(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs;
    var thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function startTimer(pendingFunc, wait) {
    if (useRAF) {
      _root.default.cancelAnimationFrame(timerId);

      return _root.default.requestAnimationFrame(pendingFunc);
    }

    return (0, _setTimeout2.default)(pendingFunc, wait);
  }

  function cancelTimer(id) {
    if (useRAF) {
      return _root.default.cancelAnimationFrame(id);
    }

    clearTimeout(id);
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time; // Start the timer for the trailing edge.

    timerId = startTimer(timerExpired, wait); // Invoke the leading edge.

    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime;
    var timeSinceLastInvoke = time - lastInvokeTime;
    var timeWaiting = wait - timeSinceLastCall;
    return maxing ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime;
    var timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.

    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = (0, _now.default)();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    } // Restart the timer.


    timerId = startTimer(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      cancelTimer(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge((0, _now.default)());
  }

  function pending() {
    return timerId !== undefined;
  }

  function debounced() {
    var time = (0, _now.default)();
    var isInvoking = shouldInvoke(time);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = startTimer(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = startTimer(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  debounced.pending = pending;
  return debounced;
}

var _default = debounce;
exports.default = _default;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(224);

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(225);

module.exports = parent;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(226);
var path = __webpack_require__(32);

module.exports = path.Date.now;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
var $ = __webpack_require__(10);
var uncurryThis = __webpack_require__(16);

var $Date = Date;
var getTime = uncurryThis($Date.prototype.getTime);

// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
$({ target: 'Date', stat: true }, {
  now: function now() {
    return getTime(new $Date());
  }
});


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * isObject({})
 * // => true
 *
 * isObject([1, 2, 3])
 * // => true
 *
 * isObject(Function)
 * // => true
 *
 * isObject(null)
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type === 'object' || type === 'function');
}

var _default = isObject;
exports.default = _default;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _globalThis2 = _interopRequireDefault(__webpack_require__(229));

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global === 'object' && global !== null && global.Object === Object && global;
/** Detect free variable `globalThis` */

var freeGlobalThis = typeof _globalThis2.default === 'object' && _globalThis2.default !== null && _globalThis2.default.Object == Object && _globalThis2.default;
/** Detect free variable `self`. */

var freeSelf = typeof self === 'object' && self !== null && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobalThis || freeGlobal || freeSelf || Function('return this')();
var _default = root;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(12)))

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(230);

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(231);


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// TODO: remove from `core-js@4`
__webpack_require__(232);

var parent = __webpack_require__(234);

module.exports = parent;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
__webpack_require__(233);


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(10);
var global = __webpack_require__(11);

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$({ global: true }, {
  globalThis: global
});


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(235);

module.exports = parent;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(236);

module.exports = parent;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(233);

module.exports = __webpack_require__(11);


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _debounce = _interopRequireDefault(__webpack_require__(222));

var _isObject = _interopRequireDefault(__webpack_require__(227));

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds (or once per browser frame). The throttled function
 * comes with a `cancel` method to cancel delayed `func` invocations and a
 * `flush` method to immediately invoke them. Provide `options` to indicate
 * whether `func` should be invoked on the leading and/or trailing edge of the
 * `wait` timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * If `wait` is omitted in an environment with `requestAnimationFrame`, `func`
 * invocation will be deferred until the next frame is drawn (typically about
 * 16ms).
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `throttle` and `debounce`.
 *
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0]
 *  The number of milliseconds to throttle invocations to; if omitted,
 *  `requestAnimationFrame` is used (if available).
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', throttle(updatePosition, 100))
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * const throttled = throttle(renewToken, 300000, { 'trailing': false })
 * jQuery(element).on('click', throttled)
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel)
 */
function throttle(func, wait, options) {
  var leading = true;
  var trailing = true;

  if (typeof func !== 'function') {
    throw new TypeError('Expected a function');
  }

  if ((0, _isObject.default)(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  return (0, _debounce.default)(func, wait, {
    leading: leading,
    trailing: trailing,
    maxWait: wait
  });
}

var _default = throttle;
exports.default = _default;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _getScrollBarSize = _interopRequireDefault(__webpack_require__(239));

var cacheOverflow = {};

var _default = function _default(close) {
  if (close) {
    // IE browser doesn't merge overflow style, need to set it separately
    if (cacheOverflow.overflow !== undefined) {
      document.body.style.overflow = cacheOverflow.overflow;
    }

    if (cacheOverflow.overflowX !== undefined) {
      document.body.style.overflowX = cacheOverflow.overflowX;
    }

    if (cacheOverflow.overflowY !== undefined) {
      document.body.style.overflowY = cacheOverflow.overflowY;
    }

    cacheOverflow = {};
  } // const bodyIsOverflowing =
  //   document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight);
  // if (!bodyIsOverflowing) {
  //   return;
  // }


  if (close) {
    document.body.style.position = '';
    document.body.style.width = '';
    return;
  }

  var scrollBarSize = (0, _getScrollBarSize.default)();

  if (scrollBarSize) {
    document.body.style.position = 'relative';

    try {
      document.body.style.width = "calc(100% - " + scrollBarSize + "px)";
    } catch (e) {}
  }

  cacheOverflow = {
    overflowX: document.body.style.overflowX,
    overflowY: document.body.style.overflowY,
    overflow: document.body.style.overflow
  };
  document.body.style.overflow = 'hidden';
};

exports.default = _default;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getScrollBarSize;
var cached;

function getScrollBarSize(fresh) {
  if (fresh || cached === undefined) {
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';
    var outer = document.createElement('div');
    var outerStyle = outer.style;
    outerStyle.position = 'absolute';
    outerStyle.top = 0;
    outerStyle.left = 0;
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }

    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }

  return cached;
}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.atob = atob;
exports.btoa = btoa;

var _indexOf = _interopRequireDefault(__webpack_require__(203));

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError'; // encoder
// [https://gist.github.com/999166] by [https://github.com/nignag]

function btoa(input) {
  var str = String(input);

  for ( // initialize result and counter
  var block, charCode, idx = 0, map = chars, output = ''; // if the next str index does not exist:
  //   change the mapping table to "="
  //   check if d has no fractional digits
  str.charAt(idx | 0) || (map = '=', idx % 1); // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
  output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
    charCode = str.charCodeAt(idx += 3 / 4);

    if (charCode > 0xff) {
      throw new InvalidCharacterError("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
    }

    block = block << 8 | charCode;
  }

  return output;
} // decoder
// [https://gist.github.com/1020396] by [https://github.com/atk]


function atob(input) {
  var str = String(input).replace(/[=]+$/, ''); // #31: ExtendScript bad parse of /=

  if (str.length % 4 === 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }

  for ( // initialize result and counters
  var bc = 0, bs, buffer, idx = 0, output = ''; // get next character
  buffer = str.charAt(idx++); // eslint-disable-line no-cond-assign
  // character found in table? initialize bit storage and add its ascii value;
  ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, // and if not first of each 4 characters,
  // convert the first 8 bits to one ascii character
  bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
    // try to find character in table (0-63, not found => -1)
    buffer = (0, _indexOf.default)(chars).call(chars, buffer);
  }

  return output;
}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(1);

var _concat = _interopRequireDefault(__webpack_require__(111));

var _slice = _interopRequireDefault(__webpack_require__(174));

var _indexOf = _interopRequireDefault(__webpack_require__(203));

/*!
 * @preserve Qwery - A Blazing Fast query selector engine
 * https://github.com/ded/qwery
 * copyright Dustin Diaz 2012
 * MIT License
 */
(function (name, context, definition) {
  if ( true && module.exports) module.exports = definition();else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {}
})('qwery', void 0, function () {
  var doc = document,
      html = doc.documentElement,
      byClass = 'getElementsByClassName',
      byTag = 'getElementsByTagName',
      qSA = 'querySelectorAll',
      useNativeQSA = 'useNativeQSA',
      tagName = 'tagName',
      nodeType = 'nodeType',
      select,
      // main select() method, assign later
  id = /#([\w\-]+)/,
      clas = /\.[\w\-]+/g,
      idOnly = /^#([\w\-]+)$/,
      classOnly = /^\.([\w\-]+)$/,
      tagOnly = /^([\w\-]+)$/,
      tagAndOrClass = /^([\w]+)?\.([\w\-]+)$/,
      splittable = /(^|,)\s*[>~+]/,
      normalizr = /^\s+|\s*([,\s\+\~>]|$)\s*/g,
      splitters = /[\s\>\+\~]/,
      splittersMore = /(?![\s\w\-\/\?\&\=\:\.\(\)\!,@#%<>\{\}\$\*\^'"]*\]|[\s\w\+\-]*\))/,
      specialChars = /([.*+?\^=!:${}()|\[\]\/\\])/g,
      simple = /^(\*|[a-z0-9]+)?(?:([\.\#]+[\w\-\.#]+)?)/,
      attr = /\[([\w\-]+)(?:([\|\^\$\*\~]?\=)['"]?([ \w\-\/\?\&\=\:\.\(\)\!,@#%<>\{\}\$\*\^]+)["']?)?\]/,
      pseudo = /:([\w\-]+)(\(['"]?([^()]+)['"]?\))?/,
      easy = new RegExp(idOnly.source + '|' + tagOnly.source + '|' + classOnly.source),
      dividers = new RegExp('(' + splitters.source + ')' + splittersMore.source, 'g'),
      tokenizr = new RegExp(splitters.source + splittersMore.source),
      chunker = new RegExp(simple.source + '(' + attr.source + ')?' + '(' + pseudo.source + ')?');
  var walker = {
    ' ': function _(node) {
      return node && node !== html && node.parentNode;
    },
    '>': function _(node, contestant) {
      return node && node.parentNode == contestant.parentNode && node.parentNode;
    },
    '~': function _(node) {
      return node && node.previousSibling;
    },
    '+': function _(node, contestant, p1, p2) {
      if (!node) return false;
      return (p1 = previous(node)) && (p2 = previous(contestant)) && p1 == p2 && p1;
    }
  };

  function cache() {
    this.c = {};
  }

  cache.prototype = {
    g: function g(k) {
      return this.c[k] || undefined;
    },
    s: function s(k, v, r) {
      v = r ? new RegExp(v) : v;
      return this.c[k] = v;
    }
  };
  var classCache = new cache(),
      cleanCache = new cache(),
      attrCache = new cache(),
      tokenCache = new cache();

  function classRegex(c) {
    return classCache.g(c) || classCache.s(c, '(^|\\s+)' + c + '(\\s+|$)', 1);
  } // not quite as fast as inline loops in older browsers so don't use liberally


  function each(a, fn) {
    var i = 0,
        l = a.length;

    for (; i < l; i++) {
      fn(a[i]);
    }
  }

  function flatten(ar) {
    for (var r = [], i = 0, l = ar.length; i < l; ++i) {
      arrayLike(ar[i]) ? r = (0, _concat.default)(r).call(r, ar[i]) : r[r.length] = ar[i];
    }

    return r;
  }

  function arrayify(ar) {
    var i = 0,
        l = ar.length,
        r = [];

    for (; i < l; i++) {
      r[i] = ar[i];
    }

    return r;
  }

  function previous(n) {
    while (n = n.previousSibling) {
      if (n[nodeType] == 1) break;
    }

    return n;
  }

  function q(query) {
    return query.match(chunker);
  } // called using `this` as element and arguments from regex group results.
  // given => div.hello[title="world"]:foo('bar')
  // div.hello[title="world"]:foo('bar'), div, .hello, [title="world"], title, =, world, :foo('bar'), foo, ('bar'), bar]


  function interpret(whole, tag, idsAndClasses, wholeAttribute, attribute, qualifier, value, wholePseudo, pseudo, wholePseudoVal, pseudoVal) {
    var i, m, k, o, classes;
    if (this[nodeType] !== 1) return false;
    if (tag && tag !== '*' && this[tagName] && this[tagName].toLowerCase() !== tag) return false;
    if (idsAndClasses && (m = idsAndClasses.match(id)) && m[1] !== this.id) return false;

    if (idsAndClasses && (classes = idsAndClasses.match(clas))) {
      for (i = classes.length; i--;) {
        var _context;

        if (!classRegex((0, _slice.default)(_context = classes[i]).call(_context, 1)).test(this.className)) return false;
      }
    }

    if (pseudo && qwery.pseudos[pseudo] && !qwery.pseudos[pseudo](this, pseudoVal)) return false;

    if (wholeAttribute && !value) {
      // select is just for existance of attrib
      o = this.attributes;

      for (k in o) {
        if (Object.prototype.hasOwnProperty.call(o, k) && (o[k].name || k) == attribute) {
          return this;
        }
      }
    }

    if (wholeAttribute && !checkAttr(qualifier, getAttr(this, attribute) || '', value)) {
      // select is for attrib equality
      return false;
    }

    return this;
  }

  function clean(s) {
    return cleanCache.g(s) || cleanCache.s(s, s.replace(specialChars, '\\$1'));
  }

  function checkAttr(qualify, actual, val) {
    switch (qualify) {
      case '=':
        return actual == val;

      case '^=':
        return actual.match(attrCache.g('^=' + val) || attrCache.s('^=' + val, '^' + clean(val), 1));

      case '$=':
        return actual.match(attrCache.g('$=' + val) || attrCache.s('$=' + val, clean(val) + '$', 1));

      case '*=':
        return actual.match(attrCache.g(val) || attrCache.s(val, clean(val), 1));

      case '~=':
        return actual.match(attrCache.g('~=' + val) || attrCache.s('~=' + val, '(?:^|\\s+)' + clean(val) + '(?:\\s+|$)', 1));

      case '|=':
        return actual.match(attrCache.g('|=' + val) || attrCache.s('|=' + val, '^' + clean(val) + '(-|$)', 1));
    }

    return 0;
  } // given a selector, first check for simple cases then collect all base candidate matches and filter


  function _qwery(selector, _root) {
    var r = [],
        ret = [],
        i,
        l,
        m,
        token,
        tag,
        els,
        intr,
        item,
        root = _root,
        tokens = tokenCache.g(selector) || tokenCache.s(selector, selector.split(tokenizr)),
        dividedTokens = selector.match(dividers);
    if (!tokens.length) return r;
    token = (tokens = (0, _slice.default)(tokens).call(tokens, 0)).pop(); // copy cached tokens, take the last one

    if (tokens.length && (m = tokens[tokens.length - 1].match(idOnly))) root = byId(_root, m[1]);
    if (!root) return r;
    intr = q(token); // collect base candidates to filter

    els = root !== _root && root[nodeType] !== 9 && dividedTokens && /^[+~]$/.test(dividedTokens[dividedTokens.length - 1]) ? function (r) {
      while (root = root.nextSibling) {
        root[nodeType] == 1 && (intr[1] ? intr[1] == root[tagName].toLowerCase() : 1) && (r[r.length] = root);
      }

      return r;
    }([]) : root[byTag](intr[1] || '*'); // filter elements according to the right-most part of the selector

    for (i = 0, l = els.length; i < l; i++) {
      if (item = interpret.apply(els[i], intr)) r[r.length] = item;
    }

    if (!tokens.length) return r; // filter further according to the rest of the selector (the left side)

    each(r, function (e) {
      if (ancestorMatch(e, tokens, dividedTokens)) ret[ret.length] = e;
    });
    return ret;
  } // compare element to a selector


  function is(el, selector, root) {
    var _context2;

    if (isNode(selector)) return el == selector;
    if (arrayLike(selector)) return !!~(0, _indexOf.default)(_context2 = flatten(selector)).call(_context2, el); // if selector is an array, is el a member?

    var selectors = selector.split(','),
        tokens,
        dividedTokens;

    while (selector = selectors.pop()) {
      tokens = tokenCache.g(selector) || tokenCache.s(selector, selector.split(tokenizr));
      dividedTokens = selector.match(dividers);
      tokens = (0, _slice.default)(tokens).call(tokens, 0); // copy array

      if (interpret.apply(el, q(tokens.pop())) && (!tokens.length || ancestorMatch(el, tokens, dividedTokens, root))) {
        return true;
      }
    }

    return false;
  } // given elements matching the right-most part of a selector, filter out any that don't match the rest


  function ancestorMatch(el, tokens, dividedTokens, root) {
    var cand; // recursively work backwards through the tokens and up the dom, covering all options

    function crawl(e, i, p) {
      while (p = walker[dividedTokens[i]](p, e)) {
        if (isNode(p) && interpret.apply(p, q(tokens[i]))) {
          if (i) {
            if (cand = crawl(p, i - 1, p)) return cand;
          } else return p;
        }
      }
    }

    return (cand = crawl(el, tokens.length - 1, el)) && (!root || isAncestor(cand, root));
  }

  function isNode(el, t) {
    return el && typeof el === 'object' && (t = el[nodeType]) && (t == 1 || t == 9);
  }

  function uniq(ar) {
    var a = [],
        i,
        j;

    o: for (i = 0; i < ar.length; ++i) {
      for (j = 0; j < a.length; ++j) {
        if (a[j] == ar[i]) continue o;
      }

      a[a.length] = ar[i];
    }

    return a;
  }

  function arrayLike(o) {
    return typeof o === 'object' && isFinite(o.length);
  }

  function normalizeRoot(root) {
    if (!root) return doc;
    if (typeof root == 'string') return qwery(root)[0];
    if (!root[nodeType] && arrayLike(root)) return root[0];
    return root;
  }

  function byId(root, id, el) {
    // if doc, query on it, else query the parent doc or if a detached fragment rewrite the query and run on the fragment
    return root[nodeType] === 9 ? root.getElementById(id) : root.ownerDocument && ((el = root.ownerDocument.getElementById(id)) && isAncestor(el, root) && el || !isAncestor(root, root.ownerDocument) && select('[id="' + id + '"]', root)[0]);
  }

  function qwery(selector, _root) {
    var m,
        el,
        root = normalizeRoot(_root); // easy, fast cases that we can dispatch with simple DOM calls

    if (!root || !selector) return [];

    if (selector === window || isNode(selector)) {
      return !_root || selector !== window && isNode(root) && isAncestor(selector, root) ? [selector] : [];
    }

    if (selector && arrayLike(selector)) return flatten(selector);

    if (m = selector.match(easy)) {
      if (m[1]) return (el = byId(root, m[1])) ? [el] : [];
      if (m[2]) return arrayify(root[byTag](m[2]));
      if (hasByClass && m[3]) return arrayify(root[byClass](m[3]));
    }

    return select(selector, root);
  } // where the root is not document and a relationship selector is first we have to
  // do some awkward adjustments to get it to work, even with qSA


  function collectSelector(root, collector) {
    return function (s) {
      var oid, nid;

      if (splittable.test(s)) {
        if (root[nodeType] !== 9) {
          // make sure the el has an id, rewrite the query, set root to doc and run it
          if (!(nid = oid = root.getAttribute('id'))) root.setAttribute('id', nid = '__qwerymeupscotty');
          s = '[id="' + nid + '"]' + s; // avoid byId and allow us to match context element

          collector(root.parentNode || root, s, true);
          oid || root.removeAttribute('id');
        }

        return;
      }

      s.length && collector(root, s, false);
    };
  }

  var isAncestor = 'compareDocumentPosition' in html ? function (element, container) {
    return (container.compareDocumentPosition(element) & 16) == 16;
  } : 'contains' in html ? function (element, container) {
    container = container[nodeType] === 9 || container == window ? html : container;
    return container !== element && container.contains(element);
  } : function (element, container) {
    while (element = element.parentNode) {
      if (element === container) return 1;
    }

    return 0;
  },
      getAttr = function () {
    // detect buggy IE src/href getAttribute() call
    var e = doc.createElement('p');
    return (e.innerHTML = '<a href="#x">x</a>') && e.firstChild.getAttribute('href') != '#x' ? function (e, a) {
      return a === 'class' ? e.className : a === 'href' || a === 'src' ? e.getAttribute(a, 2) : e.getAttribute(a);
    } : function (e, a) {
      return e.getAttribute(a);
    };
  }(),
      hasByClass = !!doc[byClass],
      // has native qSA support
  hasQSA = doc.querySelector && doc[qSA],
      // use native qSA
  selectQSA = function selectQSA(selector, root) {
    var result = [],
        ss,
        e;

    try {
      if (root[nodeType] === 9 || !splittable.test(selector)) {
        // most work is done right here, defer to qSA
        return arrayify(root[qSA](selector));
      } // special case where we need the services of `collectSelector()`


      each(ss = selector.split(','), collectSelector(root, function (ctx, s) {
        e = ctx[qSA](s);
        if (e.length == 1) result[result.length] = e.item(0);else if (e.length) result = (0, _concat.default)(result).call(result, arrayify(e));
      }));
      return ss.length > 1 && result.length > 1 ? uniq(result) : result;
    } catch (ex) {}

    return selectNonNative(selector, root);
  },
      // no native selector support
  selectNonNative = function selectNonNative(selector, root) {
    var result = [],
        items,
        m,
        i,
        l,
        r,
        ss;
    selector = selector.replace(normalizr, '$1');

    if (m = selector.match(tagAndOrClass)) {
      r = classRegex(m[2]);
      items = root[byTag](m[1] || '*');

      for (i = 0, l = items.length; i < l; i++) {
        if (r.test(items[i].className)) result[result.length] = items[i];
      }

      return result;
    } // more complex selector, get `_qwery()` to do the work for us


    each(ss = selector.split(','), collectSelector(root, function (ctx, s, rewrite) {
      r = _qwery(s, ctx);

      for (i = 0, l = r.length; i < l; i++) {
        if (ctx[nodeType] === 9 || rewrite || isAncestor(r[i], root)) result[result.length] = r[i];
      }
    }));
    return ss.length > 1 && result.length > 1 ? uniq(result) : result;
  },
      configure = function configure(options) {
    // configNativeQSA: use fully-internal selector or native qSA where present
    if (typeof options[useNativeQSA] !== 'undefined') select = !options[useNativeQSA] ? selectNonNative : hasQSA ? selectQSA : selectNonNative;
  };

  configure({
    useNativeQSA: true
  });
  qwery.configure = configure;
  qwery.uniq = uniq;
  qwery.is = is;
  qwery.pseudos = {};
  return qwery;
});

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _indexOf = _interopRequireDefault(__webpack_require__(203));

var _context, _context2, _context3;

var isIE9 = (0, _indexOf.default)(_context = navigator.userAgent.toLowerCase()).call(_context, 'msie 9.0') > -1;
var isIE8 = (0, _indexOf.default)(_context2 = navigator.userAgent.toLowerCase()).call(_context2, 'msie 8.0') > -1;
var isIE7 = (0, _indexOf.default)(_context3 = navigator.userAgent.toLowerCase()).call(_context3, 'msie 7.0') > -1;
var _default = {
  isIE9: isIE9,
  isIE8: isIE8,
  isIE7: isIE7
};
exports.default = _default;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.normalizeProps = normalizeProps;

function normalizeProps(rawProps, props) {
  var _props = {};

  for (var key in rawProps) {
    if (props[key] !== null && typeof props[key] !== 'undefined') {
      _props[key] = props[key];
    } else {
      _props[key] = rawProps[key];
    }
  }

  return _props;
}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.initModal = void 0;

var _setTimeout2 = _interopRequireDefault(__webpack_require__(124));

__webpack_require__(245);

var _util = __webpack_require__(166);

var _indexTpl = _interopRequireDefault(__webpack_require__(246));

var getRef = function getRef(ref, child) {
  return (0, _util.query)('.faicaptcha-modal' + (child ? '--' + child : ''), ref)[0];
};

var getDefaultPopupContainer = function getDefaultPopupContainer() {
  return document.body;
};

var defaultOptions = {
  title: '',
  body: '',
  beforeClose: _util.noop,
  beforeDestroy: _util.noop,
  maskClosable: true,
  getPopupContainer: getDefaultPopupContainer,
  zIndex: null
};

var initModal = function initModal(options) {
  var props = (0, _util.normalizeProps)(defaultOptions, options);
  var title = props.title,
      body = props.body,
      beforeClose = props.beforeClose,
      beforeDestroy = props.beforeDestroy,
      maskClosable = props.maskClosable,
      getPopupContainer = props.getPopupContainer,
      zIndex = props.zIndex; // init DOM

  var ref = document.createElement('div');
  ref.innerHTML = _indexTpl.default;
  getRef(ref, 'title').innerHTML = title;
  getRef(ref, 'body').innerHTML = body;

  if (zIndex) {
    getRef(ref, 'mask').style.zIndex = zIndex;
    getRef(ref, 'wrap').style.zIndex = zIndex;
  }

  var mount = function mount() {
    (0, _util.switchScrollingEffect)();
    var mountNode = getPopupContainer(ref);
    mountNode.appendChild(ref);
  };

  var timeout; // init events

  var readyToDestroy = function readyToDestroy() {
    beforeDestroy();
    (0, _util.switchScrollingEffect)(true);
    clearTimeout(timeout);
    ref.parentNode.removeChild(ref);
  };

  var close = function close() {
    var rt = beforeClose();
    if (rt === false) return;
    readyToDestroy();
  };

  var modalMousedown = false;

  _util.EventHandler.on(getRef(ref, ''), 'mousedown', function () {
    modalMousedown = true;
  });

  _util.EventHandler.on(getRef(ref, 'wrap'), 'mouseup', function () {
    timeout = (0, _setTimeout2.default)(function () {
      modalMousedown = false;
    }, 0);
  });

  _util.EventHandler.on(getRef(ref, 'wrap'), 'click', function (e) {
    if (e.target == e.currentTarget && !modalMousedown && maskClosable) {
      close();
    }
  });

  _util.EventHandler.on(getRef(ref, 'close'), 'click', function () {
    readyToDestroy();
  });

  _util.EventHandler.on(getRef(ref, 'wrap'), 'touchmove', function (e) {
    e.preventDefault();
  });

  return {
    ref: ref,
    close: close,
    mount: mount
  };
};

exports.initModal = initModal;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports = "<div> <div class=faicaptcha-modal--mask></div> <div class=\"faicaptcha-modal--wrap faicaptcha-modal--wrap__center\"><div class=faicaptcha-modal> <div class=faicaptcha-modal--content> <div class=faicaptcha-modal--close></div> <div class=faicaptcha-modal--header> <div class=faicaptcha-modal--title></div> </div> <div class=faicaptcha-modal--body></div> </div> </div> </div> </div>";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.useStatus = exports.getStatusList = void 0;

var _forEach = _interopRequireDefault(__webpack_require__(204));

var _util = __webpack_require__(166);

var NORMAL_STATUS = 'normal';
var ACTIVE_STATUS = 'active';
var DANGEROUS_STATUS = 'dangerous';
var SUCCESS_STATUS = 'success';

var getStatusList = function getStatusList(blockName) {
  return [{
    type: NORMAL_STATUS,
    className: ''
  }, {
    type: ACTIVE_STATUS,
    className: blockName + "__" + ACTIVE_STATUS
  }, {
    type: DANGEROUS_STATUS,
    className: blockName + "__" + DANGEROUS_STATUS
  }, {
    type: SUCCESS_STATUS,
    className: blockName + "__" + SUCCESS_STATUS
  }];
};

exports.getStatusList = getStatusList;

var useStatus = function useStatus(element, statusList) {
  var updateStatus = function updateStatus(status, cb) {
    if (!status) return;
    (0, _forEach.default)(statusList).call(statusList, function (_ref) {
      var type = _ref.type,
          className = _ref.className;

      if (type === status) {
        (0, _util.addClass)(element, className);

        if (status === DANGEROUS_STATUS) {
          (0, _util.whenTransitionend)(element, function () {
            updateStatus(NORMAL_STATUS);
            cb && cb();
          });
        }
      } else {
        (0, _util.removeClass)(element, className);
      }
    });
  };

  return updateStatus;
};

exports.useStatus = useStatus;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.LOCKED = void 0;
exports.lock = lock;
exports.unlock = unlock;
var LOCKED = false;
exports.LOCKED = LOCKED;

function lock() {
  exports.LOCKED = LOCKED = true;
}

function unlock() {
  exports.LOCKED = LOCKED = false;
}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports = "<div class=faicaptcha> <div class=faicaptcha_slide> <div class=faicaptcha_slide--puzzle> <img class=faicaptcha_slide--img> <img class=faicaptcha_slide--piece> <div class=faicaptcha_slide--placeholder></div> </div> <div class=faicaptcha_slide--slider> <div class=faicaptcha_slide--track_wrap> <div class=faicaptcha_slide--track> <div class=faicaptcha_slide--anchor></div> </div> </div> <div class=faicaptcha_slide--label_wrap> <i class=faicaptcha_slide--icon></i> <div class=faicaptcha_slide--label></div> </div> </div> </div> <div class=faicaptcha_graphic style=display:none> <div class=faicaptcha_graphic--main> <input class=faicaptcha_graphic--input maxlength=4> <img class=faicaptcha_graphic--img> <div class=faicaptcha_graphic--refresh></div> </div> <div class=faicaptcha_graphic--tips></div> <div class=faicaptcha_graphic--confirm></div> </div> </div>";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.validate = exports.setup = exports.registerWithLoggerV2 = exports.registerWithLogger = exports.init = void 0;
exports.validateForTypeImage = validateForTypeImage;
exports.validateForTypeImageV2 = validateForTypeImageV2;
exports.validateWithLoggerV2 = exports.validateWithLogger = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(2));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(83));

var _stringify = _interopRequireDefault(__webpack_require__(251));

var _forEach = _interopRequireDefault(__webpack_require__(204));

var _keys = _interopRequireDefault(__webpack_require__(254));

var _util = __webpack_require__(166);

var _logger = __webpack_require__(255);

var _version = __webpack_require__(256);

var _excluded = ["success", "error", "url"];
var logger = new _logger.StatisticsLogger();
var captcha_server = '';
var monitor_server = '';
var bss = '';
var bssKey = '';

var register = function register(_ref) {
  var success = _ref.success,
      error = _ref.error;
  (0, _util.ajax)({
    type: 'POST',
    url: captcha_server + "/verify/get",
    dataType: 'json',
    contentType: 'text/plain',
    data: (0, _stringify.default)({
      bss: bss,
      bssKey: bssKey,
      appKey: 1,
      version: '1.0.1'
    }),
    success: success,
    error: error
  });
};

var registerV2 = function registerV2(_ref2) {
  var url = _ref2.url,
      success = _ref2.success,
      error = _ref2.error,
      _ref2$data = _ref2.data,
      data = _ref2$data === void 0 ? {
    accessKey: ''
  } : _ref2$data;
  (0, _util.ajax)({
    type: 'POST',
    url: "//" + url + "get",
    dataType: 'json',
    contentType: 'text/plain',
    data: (0, _stringify.default)(data),
    success: success,
    error: error
  });
};

var validate = function validate(_ref3) {
  var success = _ref3.success,
      error = _ref3.error,
      validateData = _ref3.validateData;
  (0, _util.ajax)({
    type: 'POST',
    url: captcha_server + "/verify/validate",
    dataType: 'json',
    contentType: 'text/plain',
    data: validateData,
    success: success,
    error: error
  });
};

exports.validate = validate;

var validateV2 = function validateV2(_ref4) {
  var success = _ref4.success,
      error = _ref4.error,
      validateData = _ref4.validateData,
      url = _ref4.url;
  (0, _util.ajax)({
    type: 'POST',
    url: "//" + url + "validate",
    dataType: 'json',
    contentType: 'text/plain',
    data: validateData,
    success: success,
    error: error
  });
};

var init = function init(_ref5) {
  var success = _ref5.success,
      error = _ref5.error;
  (0, _util.ajax)({
    type: 'POST',
    url: captcha_server + "/verify/get",
    dataType: 'json',
    contentType: 'text/plain',
    data: (0, _stringify.default)({
      appKey: 0,
      version: '1.0.1',
      bss: bss,
      bssKey: bssKey,
      imgCodeType: 3
    }),
    success: success,
    error: error
  });
}; // 运营监控


exports.init = init;

var logMonitor = function logMonitor(monitorId) {
  (0, _util.ajax)({
    type: 'GET',
    url: captcha_server + "/verify/monitor",
    contentType: 'text/plain',
    data: {
      monitorId: monitorId
    }
  });
}; // 日志


var logMonitorInfo = function logMonitorInfo(monitorId, xhr, others) {
  var _context;

  var logInfoList = []; // base

  logInfoList.push("pcValidateCode-" + (0, _util.encodeUrl)('validateCode.js') + "::" + (0, _util.encodeUrl)('verifyCodeInit') + "-time=" + new Date());
  logInfoList.push("ua=" + navigator.userAgent); // xhr

  (0, _forEach.default)(_context = ['ajaxState', 'ajaxResponseText', 'responseStatus', 'responseStatusText']).call(_context, function (key) {
    logInfoList.push(key + "=" + xhr[key]);
  }); // monitorId

  logInfoList.push("monitorId=" + monitorId); // params

  if (others) {
    var _context2;

    (0, _forEach.default)(_context2 = (0, _keys.default)(others)).call(_context2, function (key) {
      logInfoList.push((0, _util.encodeUrl)(key) + "=" + (0, _util.encodeUrl)(others[key]));
    });
  }

  var logInfo = logInfoList.join(', ');
  (0, _util.ajax)({
    type: 'GET',
    url: captcha_server + "/verify/logMonitorInfo",
    contentType: 'text/plain',
    data: {
      logInfo: logInfo.join
    }
  });
};

var createRegisterWithLogger = function createRegisterWithLogger(api) {
  return function (_ref6) {
    var _success = _ref6.success,
        _error = _ref6.error,
        url = _ref6.url,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref6, _excluded);
    // 验证码组件faicaptcha-调用get接口次数
    logMonitor(5355);
    var startTime = new Date().getTime();
    api((0, _extends2.default)({}, rest, {
      url: url,
      success: function success() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _success.apply(this, args);

        var data = args[0];

        if (data && data.success) {
          logger.log({
            free_int_1: new Date().getTime() - startTime,
            free_text_1: 'register',
            free_text_2: _version.version,
            free_text_3: '成功'
          }); // 验证码组件faicaptcha-调用get接口成功且返回true

          logMonitor(5356);

          if (_util.Env.isIE9 || _util.Env.isIE8 || _util.Env.isIE7) {
            // 验证码组件faicaptcha-回退图形-get接口返回true
            logMonitor(5363);
          }
        } else {
          logger.log({
            free_int_1: new Date().getTime() - startTime,
            free_text_1: 'register',
            free_text_2: _version.version,
            free_text_3: '失败'
          });

          if (data && data.msg.dealType === 0) {
            // 验证码组件faicaptcha-回退图形-get接口返回false
            logMonitor(5364);
          } // 验证码组件faicaptcha-调用get接口成功且返回false


          logMonitor(5357);
          logMonitorInfo(5357, {
            requestData: (0, _stringify.default)({
              initData: "{'appKey': 1 }"
            }),
            result: data
          });
        }
      },
      error: function error() {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _error.apply(this, args);

        logger.log({
          free_int_1: new Date().getTime() - startTime,
          free_text_1: 'register',
          free_text_2: _version.version,
          free_text_3: '网络繁忙'
        }); // 验证码组件faicaptcha-调用get接口失败

        logMonitor(5358);
        var xhr = args[0];
        logMonitorInfo(5358, xhr, {
          requestData: (0, _stringify.default)({
            initData: "{'appKey': 1 }"
          }),
          error: _error
        });
      }
    }));
  };
};

var registerWithLogger = createRegisterWithLogger(register);
exports.registerWithLogger = registerWithLogger;
var registerWithLoggerV2 = createRegisterWithLogger(registerV2);
exports.registerWithLoggerV2 = registerWithLoggerV2;

var createValidateWithLogger = function createValidateWithLogger(api) {
  return function (_ref7) {
    var _success2 = _ref7.success,
        _error2 = _ref7.error,
        validateData = _ref7.validateData,
        url = _ref7.url;
    // 验证码组件faicaptcha-调用validate接口次数
    logMonitor(5359);
    var startTime = new Date().getTime();
    api({
      validateData: validateData,
      url: url,
      success: function success() {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        _success2.apply(this, args);

        var data = args[0];

        if (data && data.success) {
          // 验证码组件faicaptcha-调用validate接口成功且返回true
          logMonitor(5360);

          if (data.msg.validateResult === 0) {
            logger.log({
              free_int_1: new Date().getTime() - startTime,
              free_text_1: 'validate',
              free_text_2: _version.version,
              free_text_3: '水印未重合'
            }); // 验证码组件faicaptcha-验证失败-水印未重合

            logMonitor(5366);
          } else if (data.msg.validateResult === 1) {
            logger.log({
              free_int_1: new Date().getTime() - startTime,
              free_text_1: 'validate',
              free_text_2: _version.version,
              free_text_3: '成功'
            }); // 验证码组件faicaptcha-验证成功

            logMonitor(5367);
          } else {
            logger.log({
              free_int_1: new Date().getTime() - startTime,
              free_text_1: 'validate',
              free_text_2: _version.version,
              free_text_3: '其他错误'
            }); // 验证码组件faicaptcha-验证失败-其他错误

            logMonitor(5368);
          }
        } else {
          logger.log({
            free_int_1: new Date().getTime() - startTime,
            free_text_1: 'validate',
            free_text_2: _version.version,
            free_text_3: '失败'
          });

          if (data && data.msg.dealType === 0) {
            // 验证码组件faicaptcha-回退图形-validate接口返回false
            logMonitor(5365);
          } // 验证码组件faicaptcha-调用validate接口成功且返回false


          logMonitor(5361);
        }
      },
      error: function error() {
        logger.log({
          free_int_1: new Date().getTime() - startTime,
          free_text_1: 'validate',
          free_text_2: _version.version,
          free_text_3: '网络繁忙'
        });

        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        _error2.apply(this, args); // 验证码组件faicaptcha-调用validate接口失败


        logMonitor(5362);
      }
    });
  };
};

var validateWithLogger = createValidateWithLogger(validate);
exports.validateWithLogger = validateWithLogger;
var validateWithLoggerV2 = createValidateWithLogger(validateV2);
exports.validateWithLoggerV2 = validateWithLoggerV2;

var setup = function setup(data) {
  captcha_server = data.captcha_server || '';
  monitor_server = data.monitor_server || '';
  bss = data.bss;
  bssKey = data.bssKey;
};

exports.setup = setup;

function validateForTypeImage() {
  return validate.apply(void 0, arguments);
}

function validateForTypeImageV2() {
  return validateV2.apply(void 0, arguments);
}

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(252);

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(253);

module.exports = parent;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(199);
var path = __webpack_require__(32);
var apply = __webpack_require__(13);

// eslint-disable-next-line es-x/no-json -- safe
if (!path.JSON) path.JSON = { stringify: JSON.stringify };

// eslint-disable-next-line no-unused-vars -- required for `.length`
module.exports = function stringify(it, replacer, space) {
  return apply(path.JSON.stringify, null, arguments);
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(88);

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.StatisticsLogger = void 0;

var StatisticsLogger = /*#__PURE__*/function () {
  function StatisticsLogger() {}

  var _proto = StatisticsLogger.prototype;

  _proto.log = function log(info) {
    this.send("pub_captcha_load", info);
  };

  _proto.send = function send(event, args) {
    if (typeof Fdp !== "undefined" && Fdp.track) {
      Fdp.track(event, args);
    } else {}
  };

  return StatisticsLogger;
}();

exports.StatisticsLogger = StatisticsLogger;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.version = void 0;
var version = "2.0.4";
exports.version = version;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
// https://support.crowdin.com/api/language-codes/
var DEFAULT_LANG = 'zh-CN';
var NOT_FOUND_MSG = 'System error';
var languages = {
  'zh-CN': {
    slideRight: '向右滑动填充拼图',
    please: '请完成下方验证',
    tooMany: '初始化次数太多，请稍后重试',
    ifFails: '出现故障，切换成别的验证码',
    collapses: '拼图崩了，重新初始化',
    tryAgain: '服务器出现问题，请稍后重试',
    notCoincide: '滑块和水印不重合，请重试',
    passed: '验证通过',
    tooFast: '手速太快，请重试',
    sendFailed: '发送验证请求失败，切换验证码',
    confirm: '确定',
    placeholder: '请输入验证码',
    correct: '请输入正确验证码',
    busy: '系统繁忙，请重试'
  },
  'zh-TW': {
    slideRight: '向右滑動填充拼圖',
    please: '請完成下方驗證',
    tooMany: '初始化次數太多，請稍後重試',
    ifFails: '出現故障，切換成別的驗證碼',
    collapses: '拼圖崩了，重新初始化',
    tryAgain: '服務器出現問題，請稍後重試',
    notCoincide: '滑塊和水印不重合，請重試',
    passed: '驗證通過',
    tooFast: '手速太快，請重試',
    sendFailed: '發送驗證請求失敗，切換驗證碼',
    confirm: '確定',
    placeholder: '請輸入驗證碼',
    correct: '請輸入正確驗證碼',
    busy: '系統繁忙，請重試'
  },
  en: {
    slideRight: 'Swipe right to fill the puzzle',
    please: 'Please complete the verification below',
    tooMany: 'Too many initializations, please try again later',
    ifFails: 'In case of failure, switch to another verification code',
    collapses: 'The puzzle collapsed and reinitialized',
    tryAgain: 'There was a problem with the server, please try again later',
    notCoincide: 'Slider and watermark do not coincide, please try again',
    passed: 'Verified',
    tooFast: 'The hand speed is too fast, please try again',
    sendFailed: 'Failed to send verification request, switch verification code',
    confirm: 'determine',
    placeholder: 'please enter verification code',
    correct: 'Please enter the correct verification code',
    busy: 'System is busy, please try again'
  },
  ja: {
    slideRight: '右にスワイプしてパズルを埋めます',
    please: '以下の確認を完了してください',
    tooMany: '初期化が多すぎます。後でもう一度やり直してください',
    ifFails: '失敗した場合は、別の確認コードに切り替えます',
    collapses: 'パズルが崩壊して再初期化された',
    tryAgain: 'サーバーに問題が発生しました。しばらくしてからもう一度お試しください',
    notCoincide: 'スライダーと透かしが一致していません。もう一度やり直してください',
    passed: '確認済み',
    tooFast: '手の速度が速すぎます。もう一度お試しください',
    sendFailed: '確認リクエストを送信できませんでした。確認コードを切り替えてください',
    confirm: 'よし',
    placeholder: '確認コードを入力してください',
    correct: '正しい確認コードを入力してください',
    busy: 'システムがビジーです。もう一度やり直してください'
  },
  lo: {
    slideRight: 'ເລື່ອນຂວາເພື່ອຕື່ມຂໍ້ມູນໃສ່ປິດ',
    please: 'ກະລຸນາເຮັດການຢືນຢັນຢູ່ລຸ່ມນີ້',
    tooMany: 'ການເລີ່ມຕົ້ນຫຼາຍເກີນໄປ, ກະລຸນາລອງ ໃໝ່ ໃນພາຍຫຼັງ',
    ifFails: 'ໃນກໍລະນີຂອງຄວາມລົ້ມເຫຼວ, ປ່ຽນໄປໃຊ້ລະຫັດຢືນຢັນອື່ນ',
    collapses: 'ປິດໄດ້ລົ້ມລົງແລະ reinitialized',
    tryAgain: 'ມີປັນຫາກັບເຊີບເວີ, ກະລຸນາລອງ ໃໝ່ ໃນພາຍຫຼັງ',
    notCoincide: 'ແຖບເລື່ອນແລະເຄື່ອງ ໝາຍ ນໍ້າບໍ່ກົງກັນ, ກະລຸນາລອງ ໃໝ່ ອີກຄັ້ງ',
    passed: 'ຢັ້ງຢືນແລ້ວ',
    tooFast: 'ຄວາມໄວຂອງມືແມ່ນໄວເກີນໄປ, ກະລຸນາລອງ ໃໝ່ ອີກຄັ້ງ',
    sendFailed: 'ລົ້ມເຫລວໃນການສົ່ງ ຄຳ ຂໍຢັ້ງຢືນ, ປ່ຽນລະຫັດຢືນຢັນ',
    confirm: 'ຕົກລົງ',
    placeholder: 'ກະລຸນາໃສ່ລະຫັດຢືນຢັນ',
    correct: 'ກະລຸນາໃສ່ລະຫັດຢືນຢັນທີ່ຖືກຕ້ອງ',
    busy: 'ລະບົບຫຍຸ້ງຢູ່, ກະລຸນາລອງ ໃໝ່ ອີກຄັ້ງ'
  },
  fr: {
    slideRight: 'Balayez vers la droite pour remplir le puzzle',
    please: 'Veuillez compléter la vérification ci-dessous',
    tooMany: "Trop d'initialisations, veuillez réessayer plus tard",
    ifFails: "En cas d'échec, passez à un autre code de vérification",
    collapses: "Le puzzle s'est effondré et réinitialisé",
    tryAgain: 'Il y a eu un problème avec le serveur, veuillez réessayer plus tard',
    notCoincide: 'Le curseur et le filigrane ne coïncident pas, veuillez réessayer',
    passed: 'Vérifié',
    tooFast: 'La vitesse de la main est trop rapide, veuillez réessayer',
    sendFailed: "Échec de l'envoi de la demande de vérification, changement de code de vérification",
    confirm: 'Ok',
    placeholder: 'Veuillez saisir le code de vérification',
    correct: 'Veuillez saisir le bon code de vérification',
    busy: 'Le système est occupé, veuillez réessayer'
  },
  th: {
    slideRight: 'ปัดไปทางขวาเพื่อเติมปริศนา',
    please: 'กรุณาตรวจสอบความถูกต้องด้านล่างให้สมบูรณ์',
    tooMany: 'การกำหนดค่าเริ่มต้นมากเกินไปโปรดลองอีกครั้งในภายหลัง',
    ifFails: 'ในกรณีที่ล้มเหลวให้เปลี่ยนเป็นรหัสยืนยันอื่น',
    collapses: 'จิ๊กซอว์ทรุดตัวลงและเริ่มต้นใหม่',
    tryAgain: 'มีปัญหากับเซิร์ฟเวอร์โปรดลองอีกครั้งในภายหลัง',
    notCoincide: 'แถบเลื่อนและลายน้ำไม่ตรงโปรดลองอีกครั้ง',
    passed: 'การตรวจสอบโดย',
    tooFast: 'ความเร็วในมือเร็วเกินไปโปรดลองอีกครั้ง',
    sendFailed: 'ไม่สามารถส่งคำขอการยืนยันสลับรหัสการยืนยัน',
    confirm: 'กำหนด',
    placeholder: 'กรุณาใส่รหัสยืนยัน',
    correct: 'กรุณาใส่รหัสยืนยันที่ถูกต้อง',
    busy: 'ระบบไม่ว่างโปรดลองอีกครั้ง'
  },
  ko: {
    slideRight: '오른쪽으로 스 와이프하여 퍼즐을 채 웁니다.',
    please: '아래 확인을 완료하십시오',
    tooMany: '초기화가 너무 많습니다. 나중에 다시 시도하십시오',
    ifFails: '실패한 경우 다른 인증 코드로 전환',
    collapses: '퍼즐이 무너지고 다시 초기화되었습니다',
    tryAgain: '서버에 문제가있었습니다. 나중에 다시 시도하십시오',
    notCoincide: '슬라이더와 워터 마크가 일치하지 않습니다. 다시 시도하십시오',
    passed: '확인 됨',
    tooFast: '핸드 스피드가 너무 빠릅니다. 다시 시도하십시오',
    sendFailed: '인증 요청을 보내지 못했습니다. 인증 코드를 전환하십시오.',
    confirm: '알았어',
    placeholder: '인증 코드를 입력하십시오',
    correct: '올바른 인증 코드를 입력하십시오',
    busy: '시스템이 사용 중입니다. 다시 시도하십시오'
  },
  it: {
    slideRight: 'Scorri verso destra per riempire il puzzle',
    please: 'Si prega di completare la verifica di seguito',
    tooMany: 'Troppe inizializzazioni, riprovare più tardi',
    ifFails: 'In caso di errore, passare a un altro codice di verifica',
    collapses: 'Il puzzle è crollato e reinizializzato',
    tryAgain: 'Si è verificato un problema con il server, riprova più tardi',
    notCoincide: 'Il cursore e la filigrana non coincidono, riprovare',
    passed: 'verificato da',
    tooFast: 'La velocità della mano è troppo alta, riprova',
    sendFailed: 'Impossibile inviare la richiesta di verifica, cambiare codice di verifica',
    confirm: 'determinare',
    placeholder: 'Inserisci il codice di verifica',
    correct: 'Inserisci il codice di verifica corretto',
    busy: 'Il sistema è occupato, riprovare'
  },
  de: {
    slideRight: 'Wische nach rechts, um das Rätsel zu füllen',
    please: 'Bitte füllen Sie die unten stehende Bestätigung aus',
    tooMany: 'Zu viele Initialisierungen, versuchen Sie es später erneut',
    ifFails: 'Wechseln Sie im Fehlerfall zu einem anderen Bestätigungscode',
    collapses: 'Das Puzzle brach zusammen und wurde neu initialisiert',
    tryAgain: 'Es gab ein Problem mit dem Server. Bitte versuchen Sie es später erneut',
    notCoincide: 'Schieberegler und Wasserzeichen stimmen nicht überein. Bitte versuchen Sie es erneut',
    passed: 'Verifiziert',
    tooFast: 'Die Handgeschwindigkeit ist zu hoch, bitte versuchen Sie es erneut',
    sendFailed: 'Bestätigungsanforderung konnte nicht gesendet werden. Bestätigungscode wechseln',
    confirm: 'Ok',
    placeholder: 'Bitte geben Sie den Bestätigungscode ein',
    correct: 'Bitte geben Sie den richtigen Bestätigungscode ein',
    busy: 'System ist ausgelastet, bitte versuchen Sie es erneut'
  },
  ru: {
    slideRight: 'Проведите пальцем вправо, чтобы заполнить головоломку',
    please: 'Пожалуйста, завершите проверку ниже',
    tooMany: 'Слишком много инициализаций, попробуйте позже',
    ifFails: 'В случае сбоя переключитесь на другой проверочный код',
    collapses: 'Загадка рухнула и реинициализирована',
    tryAgain: 'Возникла проблема с сервером. Повторите попытку позже.',
    notCoincide: 'Ползунок и водяной знак не совпадают, пожалуйста, попробуйте еще раз',
    passed: 'Проверено',
    tooFast: 'Скорость руки слишком высокая, пожалуйста, попробуйте еще раз',
    sendFailed: 'Не удалось отправить запрос на подтверждение, измените код подтверждения',
    confirm: 'определить',
    placeholder: 'Пожалуйста, введите проверочный код',
    correct: 'Пожалуйста, введите правильный код подтверждения',
    busy: 'Система занята, пожалуйста, попробуйте еще раз'
  },
  es: {
    slideRight: 'Desliza hacia la derecha para completar el rompecabezas',
    please: 'Por favor complete la verificación a continuación',
    tooMany: 'Demasiadas inicializaciones, intente nuevamente más tarde',
    ifFails: 'En caso de falla, cambie a otro código de verificación',
    collapses: 'El rompecabezas se derrumbó y se reinició',
    tryAgain: 'Hubo un problema con el servidor. Vuelve a intentarlo más tarde.',
    notCoincide: 'El control deslizante y la marca de agua no coinciden, intente nuevamente',
    passed: 'Verificado',
    tooFast: 'La velocidad de la mano es demasiado rápida. Inténtalo de nuevo.',
    sendFailed: 'Error al enviar la solicitud de verificación, cambiar el código de verificación',
    confirm: 'Ok',
    placeholder: 'Por favor ingrese el código de verificación',
    correct: 'Por favor ingrese el código de verificación correcto',
    busy: 'El sistema está ocupado, intente nuevamente'
  }
};
var i18n = {
  init: function init(_ref) {
    var lang = _ref.lang;
    var language = languages[lang] || languages[DEFAULT_LANG];
    return {
      t: function t(key) {
        return language[key] || NOT_FOUND_MSG;
      }
    };
  }
};
var _default = i18n;
exports.default = _default;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.createStartFn = createStartFn;
exports.createValidateFn = createValidateFn;

var _stringify = _interopRequireDefault(__webpack_require__(251));

var _extends2 = _interopRequireDefault(__webpack_require__(2));

var _util = __webpack_require__(166);

var _api = __webpack_require__(250);

var _encrypt = __webpack_require__(259);

function createStartFnV1(faicaptcha, t, validateSignRef, eoRef) {
  var registerConfig = {
    success: function success(data) {
      if (data && data.success) {
        if (data.msg.initResult === 0) {
          faicaptcha.emit('updateTips', t('tooMany'));

          if (_util.Env.isIE9 || _util.Env.isIE8 || _util.Env.isIE7) {
            alert(t('tooMany'));
          }
        } else if (data.msg.initResult === 1) {
          faicaptcha.emit('setup', {
            imgUrl: "data:image/jpeg;base64," + data.msg.imgId,
            pieceTop: data.msg.Y,
            sliderUrl: "data:image/jpeg;base64," + data.msg.sliderId,
            sliderWidth: data.msg.sw + "px",
            sliderHeight: data.msg.sh + "px",
            imgWidth: data.msg.iw + "px",
            imgHeight: data.msg.ih + "px"
          });
          eoRef.value = data.msg.eo;
          validateSignRef.value = data.msg.validateSign;
        } else {
          faicaptcha.emit('updateTips', t('busy'));

          if (_util.Env.isIE9 || _util.Env.isIE8 || _util.Env.isIE7) {
            alert(t('tooMany'));
          }
        }

        if (_util.Env.isIE9 || _util.Env.isIE8 || _util.Env.isIE7) {
          faicaptcha.emit('updateTips', '');
          faicaptcha.emit('fallback');
        }
      } else {
        if (data && data.msg.dealType === 0) {
          faicaptcha.emit('updateTips', t('ifFails'));
          faicaptcha.emit('fallback');
        } else if (data && data.msg.dealType === 1) {
          faicaptcha.emit('updateTips', t('slideRight'));

          if (_registerRetryTimes < 3) {
            faicaptcha.emit('restart');
            _registerRetryTimes++;
          } else {
            faicaptcha.emit('updateTips', '');
            faicaptcha.emit('fallback');
          }
        } else if (data && data.msg.dealType === 2) {
          faicaptcha.emit('updateTips', t('busy'));
        } else if (data && data.msg.dealType === 3) {
          faicaptcha.emit('updateTips', t('notExisting'));
        } else {
          faicaptcha.emit('updateTips', t('busy'));
        }

        if (_util.Env.isIE9 || _util.Env.isIE8 || _util.Env.isIE7) {
          alert(t('tryAgain'));
        }
      }
    },
    error: function error() {
      faicaptcha.emit('updateTips', '');
      faicaptcha.emit('fallback');
    }
  };
  return function () {
    (0, _api.registerWithLogger)(registerConfig);
  };
}

function createStartFnV2(userConfig, faicaptcha, t, validateSignRef, eoRef, accessKeyRef) {
  var _registerRetryTimes = 0;

  var retry = function retry() {
    if (_registerRetryTimes < 3) {
      faicaptcha.emit('restart');
      _registerRetryTimes++;
    }
  };

  var registerConfig = {
    success: function success(data) {
      if (data && data.success) {
        if (data.msg.initResult === 0) {
          faicaptcha.emit('updateTips', t('tooMany')); // if (Env.isIE9 || Env.isIE8 || Env.isIE7) {
          //   alert(t('tooMany'));
          // }
        } else if (data.msg.initResult === 1) {
          // data.msg.captchaType 0=图文验证码，1-滑动拼图验证码，2-旋转拼图验证码
          if (data.msg.captchaType === 1) {
            faicaptcha.emit('setup', {
              captchaType: data.msg.captchaType,
              imgUrl: "data:image/jpeg;base64," + data.msg.imgId,
              pieceTop: data.msg.Y,
              sliderUrl: "data:image/jpeg;base64," + data.msg.sliderId,
              sliderWidth: data.msg.sw + "px",
              sliderHeight: data.msg.sh + "px",
              imgWidth: data.msg.iw + "px",
              imgHeight: data.msg.ih + "px"
            });
            eoRef.value = data.msg.eo;
            validateSignRef.value = data.msg.validateSign;
          } else if (data.msg.captchaType === 2) {
            faicaptcha.emit('setup', {
              captchaType: data.msg.captchaType,
              imgUrl: "data:image/jpeg;base64," + data.msg.resultOriginalImg,
              pieceTop: data.msg.Y,
              pieceLeft: data.msg.x,
              sliderUrl: "data:image/jpeg;base64," + data.msg.resultImg,
              sliderWidth: data.msg.diameter,
              sliderHeight: data.msg.diameter,
              imgWidth: data.msg.iw,
              imgHeight: data.msg.ih
            });
            eoRef.value = data.msg.eo;
            validateSignRef.value = data.msg.validateSign;
          } else {
            faicaptcha.emit('updateTips', '');
            faicaptcha.emit('initForGraphic');
            faicaptcha.emit('setup', {
              captchaType: data.msg.captchaType,
              imgUrl: "data:image/jpeg;base64," + data.msg.imgId
            });
            eoRef.value = data.msg.eo;
            validateSignRef.value = data.msg.validateSign;
          }
        } else {
          faicaptcha.emit('updateTips', t('busy')); // if (Env.isIE9 || Env.isIE8 || Env.isIE7) {
          //   alert(t('tooMany'));
          // }
        } // if (Env.isIE9 || Env.isIE8 || Env.isIE7) {
        //   faicaptcha.emit('updateTips', '');
        //   faicaptcha.emit('fallback');
        // }

      } else {
        if (data && data.msg.dealType === 0) {
          faicaptcha.emit('updateTips', t('ifFails')); // faicaptcha.emit('fallback');

          retry();
        } else if (data && data.msg.dealType === 1) {
          faicaptcha.emit('updateTips', t('slideRight')); // if (_registerRetryTimes < 3) {
          //   faicaptcha.emit('restart');
          //   _registerRetryTimes++;
          // } else {
          //   faicaptcha.emit('updateTips', '');
          //   faicaptcha.emit('fallback');
          // }

          retry();
        } else if (data && data.msg.dealType === 2) {
          faicaptcha.emit('updateTips', t('busy'));
        } else if (data && data.msg.dealType === 3) {
          faicaptcha.emit('updateTips', t('notExisting'));
        } else {
          faicaptcha.emit('updateTips', t('busy'));
        } // if (Env.isIE9 || Env.isIE8 || Env.isIE7) {
        //   alert(t('tryAgain'));
        // }

      }
    },
    error: function error() {
      // faicaptcha.emit('updateTips', '');
      // faicaptcha.emit('fallback');
      retry();
    }
  };
  return function () {
    userConfig.genAccessKey(function (accessKey) {
      accessKeyRef.value = accessKey;
      var info = JSON.parse((0, _util.atob)(accessKeyRef.value));
      var url = "" + info.domain + info.uri;
      (0, _api.setup)({
        captcha_server: '//' + info.domain
      });
      (0, _api.registerWithLoggerV2)((0, _extends2.default)({}, registerConfig, {
        url: url,
        data: {
          accessKey: accessKey
        }
      }));
    });
  };
}

function createStartFn(userConfig, faicaptcha, t, validateSignRef, eoRef, accessKeyRef) {
  if (userConfig.genAccessKey) {
    return createStartFnV2(userConfig, faicaptcha, t, validateSignRef, eoRef, accessKeyRef);
  } else {
    return createStartFnV1(faicaptcha, t, validateSignRef, eoRef);
  }
}

function createValidateFnV2(userConfig, faicaptcha, t, validateSignRef, eoRef, accessKeyRef, onSuccess) {
  var _registerRetryTimes = 0;

  var retry = function retry() {
    if (_registerRetryTimes < 3) {
      faicaptcha.emit('restart');
      _registerRetryTimes++;
    }
  };

  return function (args, captchaType) {
    var info = JSON.parse((0, _util.atob)(accessKeyRef.value));
    var url = "" + info.domain + info.uri; // 滑块验证

    if (captchaType === 1) {
      var data = (0, _encrypt.encryptV2)((0, _extends2.default)({}, args, {
        eo: eoRef.value,
        validateSign: validateSignRef.value,
        accessKey: accessKeyRef.value
      }));
      (0, _api.validateWithLoggerV2)({
        url: url,
        validateData: (0, _stringify.default)(data),
        success: function success(data) {
          faicaptcha.emit('validated', {
            success: data && data.success && data.msg.validateResult === 1
          });

          if (data && data.success) {
            if (data.msg.validateResult === 0) {
              faicaptcha.emit('updateTips', t('notCoincide'));
            } else if (data.msg.validateResult === 1) {
              faicaptcha.emit('updateTips', t('passed'));
              faicaptcha.once('finished', function () {
                onSuccess(data.msg.checkSign);
              });
            } else if (data.msg.validateResult === 2) {
              faicaptcha.emit('updateTips', t('tooFast'));
            } else if (data.msg.validateResult === 3) {
              faicaptcha.emit('updateTips', t('slideRight')); // faicaptcha.emit('restart');

              retry();
            } else if (data.msg.validateResult === 4) {
              faicaptcha.emit('updateTips', t('busy'));
            }
          } else {
            if (data && data.msg.dealType === 0) {
              // faicaptcha.emit('fallback');
              faicaptcha.emit('updateTips', t('ifFails'));
              retry();
            } else if (data && data.msg.dealType === 1) {
              faicaptcha.emit('updateTips', t('slideRight')); // faicaptcha.emit('restart');

              retry();
            } else if (data && data.msg.dealType === 2) {
              faicaptcha.emit('updateTips', t('busy'));
            } else if (data && data.msg.dealType === 3) {
              faicaptcha.emit('updateTips', t('notExisting'));
            } else {
              faicaptcha.emit('updateTips', t('busy'));
            }
          }
        },
        error: function error() {
          // faicaptcha.emit('fallback');
          faicaptcha.emit('updateTips', t('sendFailed'));
          retry();
        }
      });
    } else if (captchaType === 2) {
      // 旋转验证
      var _data = (0, _encrypt.encrypt2V2)((0, _extends2.default)({}, args, {
        eo: eoRef.value,
        validateSign: validateSignRef.value,
        accessKey: accessKeyRef.value
      }));

      (0, _api.validateWithLoggerV2)({
        validateData: (0, _stringify.default)(_data),
        url: url,
        success: function success(data) {
          faicaptcha.emit('validated2', {
            success: data && data.success && data.msg.validateResult === 1
          });

          if (data && data.success) {
            if (data.msg.validateResult === 0) {
              faicaptcha.emit('updateTips', t('notCoincide'));
            } else if (data.msg.validateResult === 1) {
              faicaptcha.emit('updateTips', t('passed'));
              faicaptcha.once('finished', function () {
                onSuccess(data.msg.checkSign);
              });
            } else if (data.msg.validateResult === 2) {
              faicaptcha.emit('updateTips', t('tooFast'));
            } else if (data.msg.validateResult === 3) {
              faicaptcha.emit('updateTips', t('slideRight')); // faicaptcha.emit('restart');

              retry();
            } else if (data.msg.validateResult === 4) {
              faicaptcha.emit('updateTips', t('busy'));
            }
          } else {
            if (data && data.msg.dealType === 0) {
              // faicaptcha.emit('fallback');
              faicaptcha.emit('updateTips', t('ifFails'));
              retry();
            } else if (data && data.msg.dealType === 1) {
              faicaptcha.emit('updateTips', t('slideRight')); // faicaptcha.emit('restart');

              retry();
            } else if (data && data.msg.dealType === 2) {
              faicaptcha.emit('updateTips', t('busy'));
            } else if (data && data.msg.dealType === 3) {
              faicaptcha.emit('updateTips', t('notExisting'));
            } else {
              faicaptcha.emit('updateTips', t('busy'));
            }
          }
        },
        error: function error() {
          // faicaptcha.emit('fallback');
          faicaptcha.emit('updateTips', t('sendFailed'));
          retry();
        }
      });
    } else {
      // 图片验证
      var _data2 = (0, _encrypt.encrypt0V2)((0, _extends2.default)({
        validateSign: validateSignRef.value,
        accessKey: accessKeyRef.value
      }, args));

      (0, _api.validateForTypeImageV2)({
        validateData: (0, _stringify.default)(_data2),
        url: url,
        success: function success(data) {
          faicaptcha.emit('validated0', {
            success: data && data.success && data.msg.validateResult === 1
          });

          if (data && data.success) {
            if (data.msg.validateResult === 0) {
              faicaptcha.emit('updateTipsForGraphic', t('correct')); // faicaptcha.emit('refreshImg');

              retry();
            } else if (data.msg.validateResult === 1) {
              faicaptcha.emit('updateTipsForGraphic', t('passed'));
              faicaptcha.once('finished', function () {
                onSuccess(data.msg.checkSign);
              });
            } else {
              faicaptcha.emit('updateTipsForGraphic', t('busy')); // faicaptcha.emit('refreshImg');

              retry();
            }
          } else {
            faicaptcha.emit('updateTipsForGraphic', t('busy')); // faicaptcha.emit('refreshImg');

            retry();
          }
        },
        error: function error() {
          faicaptcha.emit('updateTipsForGraphic', t('busy')); // faicaptcha.emit('refreshImg');

          retry();
        }
      });
    }
  };
}

function createValidateFnV1(userConfig, faicaptcha, t, validateSignRef, eoRef, accessKeyRef, onSuccess) {
  return function (args, captchaType) {
    // 滑块验证
    if (captchaType === 1) {
      var data = (0, _encrypt.encrypt)((0, _extends2.default)({}, args, {
        eo: eoRef.value,
        bss: userConfig.bss,
        bssKey: userConfig.bssKey,
        validateSign: validateSignRef.value
      }));
      (0, _api.validateWithLogger)({
        validateData: (0, _stringify.default)(data),
        success: function success(data) {
          faicaptcha.emit('validated', {
            success: data && data.success && data.msg.validateResult === 1
          });

          if (data && data.success) {
            if (data.msg.validateResult === 0) {
              faicaptcha.emit('updateTips', t('notCoincide'));
            } else if (data.msg.validateResult === 1) {
              faicaptcha.emit('updateTips', t('passed'));
              faicaptcha.once('finished', function () {
                onSuccess(data.msg.checkSign);
              });
            } else if (data.msg.validateResult === 2) {
              faicaptcha.emit('updateTips', t('tooFast'));
            } else if (data.msg.validateResult === 3) {
              faicaptcha.emit('updateTips', t('slideRight'));
              faicaptcha.emit('restart');
            } else if (data.msg.validateResult === 4) {
              faicaptcha.emit('updateTips', t('busy'));
            }
          } else {
            if (data && data.msg.dealType === 0) {
              faicaptcha.emit('fallback');
              faicaptcha.emit('updateTips', t('ifFails'));
            } else if (data && data.msg.dealType === 1) {
              faicaptcha.emit('updateTips', t('slideRight'));
              faicaptcha.emit('restart');
            } else if (data && data.msg.dealType === 2) {
              faicaptcha.emit('updateTips', t('busy'));
            } else if (data && data.msg.dealType === 3) {
              faicaptcha.emit('updateTips', t('notExisting'));
            } else {
              faicaptcha.emit('updateTips', t('busy'));
            }
          }
        },
        error: function error() {
          faicaptcha.emit('fallback');
          faicaptcha.emit('updateTips', t('sendFailed'));
        }
      });
    } else {
      // 图片验证
      var _data3 = (0, _encrypt.encrypt0)((0, _extends2.default)({
        validateSign: validateSign,
        bss: userConfig.bss,
        bssKey: userConfig.bssKey
      }, args));

      (0, _api.validateForTypeImage)({
        validateData: (0, _stringify.default)(_data3),
        success: function success(data) {
          faicaptcha.emit('validated0', {
            success: data && data.success && data.msg.validateResult === 1
          });

          if (data && data.success) {
            if (data.msg.validateResult === 0) {
              faicaptcha.emit('updateTips', t('correct'));
              faicaptcha.emit('refreshImg');
            } else if (data.msg.validateResult === 1) {
              faicaptcha.emit('updateTips', t('passed'));
              faicaptcha.once('finished', function () {
                onSuccess(data.msg.checkSign);
              });
            } else {
              faicaptcha.emit('updateTips', t('busy'));
              faicaptcha.emit('refreshImg');
            }
          } else {
            faicaptcha.emit('updateTips', t('busy'));
            faicaptcha.emit('refreshImg');
          }
        },
        error: function error() {
          faicaptcha.emit('updateTips', t('busy'));
          faicaptcha.emit('refreshImg');
        }
      });
    }
  };
}

function createValidateFn(userConfig, faicaptcha, t, validateSignRef, eoRef, accessKeyRef, onSuccess) {
  if (userConfig.genAccessKey) {
    return createValidateFnV2(userConfig, faicaptcha, t, validateSignRef, eoRef, accessKeyRef, onSuccess);
  } else {
    return createValidateFnV1(userConfig, faicaptcha, t, validateSignRef, eoRef, accessKeyRef, onSuccess);
  }
}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.encrypt = encrypt;
exports.encrypt0 = encrypt0;
exports.encrypt0V2 = encrypt0V2;
exports.encrypt2V2 = encrypt2V2;
exports.encryptV2 = encryptV2;

var _stringify = _interopRequireDefault(__webpack_require__(251));

var _util = __webpack_require__(166);

// 旋转加密v2 only v2
function encrypt2V2(_ref) {
  var degree = _ref.left,
      track = _ref.track,
      eo = _ref.eo,
      validateSign = _ref.validateSign,
      accessKey = _ref.accessKey;
  return {
    accessKey: accessKey,
    et: eo.et,
    vi: (0, _util.btoa)((0, _stringify.default)({
      t: track,
      degree: degree,
      fp: {},
      validateSign: validateSign
    }))
  };
} // 滑块加密v2


function encryptV2(_ref2) {
  var accessKey = _ref2.accessKey,
      eo = _ref2.eo,
      left = _ref2.left,
      track = _ref2.track,
      validateSign = _ref2.validateSign;
  return {
    accessKey: accessKey,
    et: eo.et,
    vi: (0, _util.btoa)((0, _stringify.default)({
      l: left,
      t: track,
      fp: {},
      validateSign: validateSign
    }))
  };
} // 滑块加密


function encrypt(_ref3) {
  var left = _ref3.left,
      downY = _ref3.downY,
      upY = _ref3.upY,
      track = _ref3.track,
      eo = _ref3.eo,
      validateSign = _ref3.validateSign,
      bss = _ref3.bss,
      bssKey = _ref3.bssKey;
  return {
    appKey: 1,
    et: eo.et,
    bss: bss,
    bssKey: bssKey,
    version: '1.0.1',
    vi: (0, _util.btoa)((0, _stringify.default)({
      s: 10,
      l: left,
      dy: downY,
      uy: upY,
      t: track,
      validateSign: validateSign
    }))
  };
} // 图片加密


function encrypt0V2(_ref4) {
  var validateSign = _ref4.validateSign,
      code = _ref4.code,
      accessKey = _ref4.accessKey;
  return {
    accessKey: accessKey,
    vi: (0, _util.btoa)((0, _stringify.default)({
      validateSign: validateSign,
      code: code,
      dp: {}
    }))
  };
} // 图片加密


function encrypt0(_ref5) {
  var validateSign = _ref5.validateSign,
      code = _ref5.code,
      bss = _ref5.bss,
      bssKey = _ref5.bssKey;
  return {
    appKey: 0,
    version: '1.0.1',
    bss: bss,
    bssKey: bssKey,
    vi: (0, _util.btoa)((0, _stringify.default)({
      validateSign: validateSign,
      code: code
    }))
  };
}

/***/ })
/******/ ]);
});
//# sourceMappingURL=faicaptcha.js.map